<style>
th.td-check .con-vs-checkbox {
  margin-right: 0 !important;
  display: none !important;
  margin-left: 0 !important;
}
.signature_pad {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
</style>

<template>
  <vx-card>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <h4>Gestión de hojas de recepción</h4>
          </div>
        </div>
        <hr />
        <div class="vx-row mt-2">
          <div class="vx-col md:w-1/4 sm:w-full w-full">
            <label for>Fecha inicial</label>
            <datepicker
              v-model="fcalendarEdit"
              color="grey darken-4"
              :language="languages.es"
              format="yyyy-MM-dd"
            ></datepicker>
            <!-- <v-date-picker v-model="fcalendarEdit" @input="mfechaEdit = false" color="grey darken-4" locale="es"></v-date-picker> -->
          </div>
          <div class="vx-col md:w-1/4 sm:w-full w-full">
            <label for>Fecha final</label>
            <datepicker
              v-model="fcalendarFinal"
              color="grey darken-4"
              :language="languages.es"
              format="yyyy-MM-dd"
            ></datepicker>
          </div>
          <div class="vx-col md:w-1/4 sm:w-full w-full pt-5">
            <vs-button
              color="primary"
              class="w-full"
              type="border"
              icon-pack="feather"
              icon="icon-search"
              v-on:click="searchRecepcion()"
            >Buscar</vs-button>
          </div>
          <div class="vx-col md:w-1/4 sm:w-full w-full pt-5">
            <vs-button
              color="dark"
              class="w-full"
              type="border"
              icon-pack="feather"
              icon="icon-plus"
              @click="ActivePopup()"
            >Agregar</vs-button>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <div class="vx-row mt-2">
      <div class="vx-col w-full">
        <ag-grid-vue
          ref="agGridTable"
          v-if="renderComponents"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="datos.columnDefs"
          :defaultColDef="datos.defaultColDef"
          :rowData="datos.json"
          autoSizeColumns="true"
          :animateRows="false"
          :floatingFilter="false"
          :pagination="false"
          :suppressDragLeaveHidesColumns="false"
          :suppressMovable="false"
          :suppressPaginationPanel="false"
          overlayNoRowsTemplate="No se encontraron resultados."
          :enableRtl="$vs.rtl"
          style="max-height: 400px;width:100%"
          id
        ></ag-grid-vue>
      </div>
    </div>

    <vs-popup fullscreen :title="titlePopup" :active.sync="popupActive">
      <form-wizard
        ref="wizard"
        color="rgba(var(--vs-primary), 1)"
        errorColor="rgba(var(--vs-danger), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Guardar"
        nextButtonText="Siguiente"
        backButtonText="Regresar"
        @on-complete="formSubmitted"
        @on-change="handleValidation"
      >
        <tab-content title="Datos generales" class="mb-5" :before-change="validateStep1">
          <!-- tab 1 content -->
          <form data-vv-scope="step-1">
            <div class="vx-row">
              <!-- cliente -->
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgCliente.fgVisible">
                <label for>Cliente</label>
                <v-select
                  v-model="idCliente"
                  :options="options1"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"                  
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}" id="template1">
                    <input
                      class="vs__search"
                      :required="!idCliente"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idCliente"
                      v-validate="!idCliente ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger validate-message">{{ errors.first('step-1.v_idCliente') }}</span>
                <br />
              </div>
              <!-- TipoDocumento -->
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgTipoDocumento.fgVisible">
                <label for>Tipo de documento</label>
                <v-select
                  v-model="idTipoDocumento"
                  :options="options2"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"                  
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idTipoDocumento"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idTipoDocumento"
                      v-validate="!idTipoDocumento ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-1.v_idTipoDocumento') }}</span>
              </div>
              <!-- TipoVehiculo -->
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgTipoVehiculo.fgVisible">
                <label for>Tipo de Vehículo</label>
                <v-select
                  v-model="idTipoVehiculo"
                  :options="TiposVehiculos"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"                  
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idTipoVehiculo"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idTipoVehiculo"
                      v-validate="!idTipoVehiculo ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-1.v_idTipoVehiculo') }}</span>
              </div>
              <!-- Vehiculo -->
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgVehiculo.fgVisible">
                <label for>Vehículo</label>
                <v-select
                  v-model="idVehiculo"
                  :options="options4"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"                  
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idVehiculo"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idVehiculo"
                      v-validate="!idVehiculo ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-1.v_idVehiculo') }}</span>
              </div>
              <!-- Nombre -->
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgNombreCliente.fgVisible">
                <label for>Nombre</label>
                <vs-input
                  v-model="Nombre"
                  class="w-full"
                  name="v_Nombre"                  
                  maxlength="250"
                />
                <span class="text-danger validate-message">{{ errors.first('step-1.v_Nombre') }}</span>
              </div>
              
              <!-- <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgTipoChasis.fgVisible">
                <label for>Tipo de chasis</label>
                <v-select v-model="idTipoChasis" :options="options3" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idTipoChasis"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idTipoChasis"
                      v-validate="!idTipoChasis ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-1.v_idTipoChasis') }}</span>
              </div>-->
              <!-- </div> -->
              <!-- <div class="vx-row"> -->
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgContrato.fgVisible">
                <label for>Contrato</label>
                <vs-input
                  v-model="Contrato"
                  class="w-full"
                  name="v_Contrato"
                  maxlength="250"                  
                />
                <span class="text-danger">{{ errors.first('step-1.v_Contrato') }}</span>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgFactura.fgVisible">
                <label for>Factura</label>
                <vs-input
                  v-model="Factura"
                  class="w-full"
                  name="v_Factura"
                  maxlength="250"                  
                />
                <span class="text-danger">{{ errors.first('step-1.v_Factura') }}</span>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgEstacion.fgVisible">
                <label for>Sucursal</label>
                <v-select
                  v-model="idEstacion"
                  :options="options5"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"                  
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idEstacion"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idEstacion"
                      v-validate="!idEstacion && fgEstacion.fgVisible ? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-1.v_idEstacion') }}</span>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgInspector.fgVisible">
                <label for>Inspector de operaciones</label>
                <v-select
                  v-model="idEmpleado"
                  :options="options6"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"                  
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idEmpleado"
                      v-bind="attributes"
                      v-on="events"
                      name="v_idEmpleado"
                      v-validate="!idEmpleado? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span class="text-danger">{{ errors.first('step-1.v_idEmpleado') }}</span>
              </div>
            </div>
            <hr class="my-3" />
            <div class="vx-row">
              <div class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5">
                <label for>Marca y Modelo</label>
                <vs-input v-model="MarcaModelo" disabled class="w-full" />
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5">
                <label for>Descripción</label>
                <vs-input v-model="Descripcion" disabled class="w-full" />
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/3 w-full mt-5">
                <label for>Placas</label>
                <vs-input v-model="Placa" disabled class="w-full" />
              </div>
            </div>
            <div class="vx-row" v-if="fgVisibleLlanta">
              <hr class="my-5" />
              <h5 v-if="fgVisibleLlanta" class="mt-5">Llantas</h5>
            </div>
            <div class="vx-row" v-if="fgVisibleLlanta">
              <div
                class="vx-col lg:1/4 md:w-1/3 sm:w-full w-full mt-5"
                :key="index"
                v-for="(item, index) in LsLlantas"
              >
                <vx-card>
                  <b>NS:</b>
                  {{item.SN}}
                  <br />
                  <b>ECO:</b>
                  {{item.NumeroEconomico}}
                  <br />
                  <b>MARCA:</b>
                  {{item.Marca}}
                  <br />
                  <b>MOD:</b>
                  {{item.Modelo}}
                </vx-card>
              </div>
            </div>
          </form>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content
          title="Estatus inicial del vehículo"
          class="mb-5"
          :before-change="validateStep2"
        >
          <form data-vv-scope="step-2">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgkilometraje.fgVisible">
                <label for>Kilometraje</label>
                <vs-input
                  v-model="Kilometraje"
                  class="w-full"
                  name="v_Kilometraje"
                  v-validate="'required'"
                />
                <span class="text-danger">{{ errors.first('step-2.Kilometraje') }}</span>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" >
                <label for="">Combustible de salida</label>
                <v-select
                  v-model="idCombustible"
                  :options="options7"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idCombustible"
                      v-bind="attributes"
                      v-on="events"
                      :disabled="Activo == 1 ? true : false"
                      name="v_idCombustible"
                      v-validate="!idCombustible? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span
                  class="text-danger"
                >{{ errors.first('step-2.v_idCombustible') }}</span>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgFechaInicio.fgVisible">
                <label for>Fecha de inicio</label>
                <datepicker
                  v-model="fSalida"
                  color="grey darken-4"
                  :language="languages.es"
                  format="yyyy-MM-dd"
                  :disabled-dates="disabledDates"
                ></datepicker>
              </div>
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="fgFechaFinal.fgVisible">
                <label for>Fecha de salida</label>
                <datepicker
                  v-model="fLlegada"
                  color="grey darken-4"
                  :language="languages.es"
                  format="yyyy-MM-dd"
                  :disabled-dates="disabledDates"
                ></datepicker>
              </div>
              <!-- </div>
              <div class="vx-row">-->
            </div>
            <div class="vx-row">
              <div class="vx-col w-full mt-5" v-show="fgObservaciones.fgVisible">
                <label for>Detalles del servicio</label>
                <vs-textarea v-model="Comentarios" class="mb-0" rows="3" />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5">
                  <vs-checkbox v-model="checkRutinas" title="Rutinas"
                        @change="getEstatusRutinas()">
                         <label>Seleccionar Rutinas</label>
                  </vs-checkbox>
                  
                </div>
                <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5">
                <vs-checkbox v-model="checkServicios" title="Servicios"
                        @change="getEstatusServicios()">
                          <label>Seleccionar Servicios</label>
                  </vs-checkbox>
                </div>
            </div>
            <div class="vx-row">
              <!-- Rutinas -->
              <div class="vx-col md:w-1/2 lg:w-1/4 w-full mt-5" v-show="showRutinas">
                <label for="">Rutina</label>
                <v-select
                  v-model="idRutina"
                  :options="optionsRutinas"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                >
                  <template #no-options="{  }">No se encontraron resultados.</template>
                  <template #search="{attributes, events}">
                    <input
                      class="vs__search"
                      :required="!idRutina"
                      v-bind="attributes"
                      v-on="events"
                      :disabled="Activo == 1 ? true : false"
                      name="v_idRutina"
                      v-validate="!idRutina? 'required' : ''"
                    />
                  </template>
                </v-select>
                <span
                  class="text-danger"
                >{{ errors.first('step-2.v_idRutina') }}</span>
              </div>
              <!-- Servicios vehiculares-->
              <div class="vx-col w-full mt-5" v-show="showServices">
                <vs-table
                :data="dataServicios"
              >
                <template slot="header">
                  <vs-switch style="width: 9%;" v-model="busquedaExacta">
                    <template #off>
                      Busqueda Exacta
                    </template>
                    <template #on>
                      Buesqueda Exacta
                    </template>
                  </vs-switch>
                  <vs-input style="width: 50%;" v-model="search" border placeholder="Search" @keypress="searchServices()" @change="searchServices()" />
                  
                  <label>{{textoTotalServicios}}</label>
                  <label style="color:blue; cursor:help;" v-on:click="verServiciosSeleccionados()">{{textoTotalServiciosSeleccionados}}</label>
                </template>
                <template slot="thead">
                    <!-- <vs-tr
                      v-for="(th,i) in dataColumnsServices"
                      :key="i"
                      :data="th"
                    >
                      <vs-th>
                        <vs-checkbox
                        :indeterminate="false" v-model="allCheck"
                        @change="checkAllServices()"
                        />
                      </vs-th>
                      <vs-th>
                        {{th.Nombre}}
                      </vs-th>
                      <vs-th>
                        {{th.TipoServicioNombre}}
                      </vs-th>
                    </vs-tr> -->
                    <p></p>
                </template>
                <template slot-scope="{data}">
                  <vs-tr
                      v-for="(th,i) in dataColumnsServices"
                      :key="i"
                      :data="th"
                    >
                      <vs-th>
                        <vs-checkbox
                        :indeterminate="false" v-model="allCheck"
                        @change="checkAllServices()"
                        />
                      </vs-th>
                      <vs-th>
                        {{th.Nombre}}
                      </vs-th>
                      <vs-th>
                        {{th.TipoServicioNombre}}
                      </vs-th>
                    </vs-tr>
                      <vs-tr
                        v-for="(tr, i) in data"
                        :key="i"
                        :data="tr"
                      >
                        <vs-td checkbox>
                          <vs-checkbox :val="tr" v-model="tr.chequeado" @click="checkItemService(tr,$event)" />
                        </vs-td>
                        <vs-td>
                          {{ tr.Nombre }}
                        </vs-td>
                        <vs-td>
                        {{ tr.TipoServicioNombre }}
                        </vs-td>
                      </vs-tr>
                </template>
                
              </vs-table>
              
              <!--Paginacion-->
              <vs-nav>
                <vs-ul-group style="display: flex;flex-wrap: wrap;border: 1px solid #c3c3c3;">
                  <vs-li v-on:click="getPreviousPage()" style="cursor:pointer;"><a>previus</a></vs-li>
                  <vs-li :key="i" v-for="(p,i) in totalPaginasServices" v-on:click="getDataPagina(p)" style="cursor:pointer;margin-left:1em;"><a>{{p}}</a></vs-li>
                  <vs-li v-on:click="getNetxPage()" style="cursor:pointer;margin-left:1em;"><a>netx</a></vs-li>
                </vs-ul-group>
              </vs-nav>
              <!--fin Paginacion-->
              
              </div>
              <!-- fin Servicios vehiculares-->
            </div>
          </form>
        </tab-content>

        <!-- tab 3 content -->
        <tab-content title="Check vehículo" class="mb-5" :before-change="validateStep3">
          <div class="vx-row">
            <div
              class="vx-col md:w-1/2 lg:w-1/3 sm:w-full w-full mt-5"
              v-for="(seccion, i) in CuestionarioEmpresa.Secciones"
              :key="i"
            >
              <h5>{{seccion.NombreSeccion}}</h5>
              <hr class="mt-5" />
              <vs-table
                multiple
                v-model="selected"
                :data="CuestionarioEmpresa.Secciones[i].Preguntas"
                :id="'table_' + i"
                :key="i"
              >
                <template slot="thead" :id="'thead_' + i">
                  <tr>
                    <th style="display:none"></th>
                    <th>Seleccionar</th>
                  </tr>
                  <!-- <vs-th>Seleccionar todos</vs-th> -->
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr+'_'+i" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].PreguntaID">{{data[indextr].Pregunta}}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </tab-content>

        <!-- tab 4 content -->
        <tab-content title="Detalles del vehículo" class="mb-5" :before-change="validateStep4">
          <div class="vx-row">
            <div class="vx-col w-full">
              <span
                class="material-icons"
                style="font-size:24px; color:#ea728c;vertical-align: bottom;"
              >fiber_manual_record</span>
              <span style="color:black">Abolladura</span>
              <span
                class="material-icons"
                style="font-size:24px; color:#baf1a1; vertical-align: bottom;"
              >fiber_manual_record</span> Rayón
              <span
                class="material-icons"
                style="font-size:24px; color:#459CD2;vertical-align: bottom;"
              >fiber_manual_record</span> Daño genérico
            </div>
          </div>
          <hr class="my-3" />
          <div class="vx-row">
            <vx-card style="min-width:800px">
              <div class="vx-row">
                <div class="vx-col md:w-full lg:w-1/2 w-full">
                  <!-- <img :src="card_1.img" alt="content-img" class="responsive card-img-top"> -->
                  <!-- <div
                    @click="getCordenadas"
                    id="img-element"
                    aspect-ratio="1"
                    :style="'width:600px;height: 300px;background-image: url(' + imgCarro + ');background-position: center center;background-size: contain;background-repeat: no-repeat;'"
                  ></div>-->
                  <img
                    v-bind:src="imgCarro"
                    aspect-ratio="1"
                    class
                    style="border:2px gray solid;width:600px; height: 300px;"
                    draggable="false"
                    @click="getCordenadas"
                    id="img-element"
                  />
                  <div v-html="svgTest" ref="incomingDef"></div>
                  <div v-html="pointOne" ref="incomingDef"></div>
                  <div v-html="pointTwo" ref="incomingDef"></div>
                  <div v-html="pointThre" ref="incomingDef"></div>
                  <div v-html="pointFor" ref="incomingDef"></div>
                  <div v-html="pointFive" ref="incomingDef"></div>
                  <div v-html="pointSix" ref="incomingDef"></div>
                  <div v-html="pointSeven" ref="incomingDef"></div>
                  <div v-html="pointEigth" ref="incomingDef"></div>
                  <div v-html="pointNine" ref="incomingDef"></div>
                  <div v-html="pointTen" ref="incomingDef"></div>
                  <div v-html="pointEleven" ref="incomingDef"></div>
                  <div v-html="pointTwelve" ref="incomingDef"></div>
                  <div v-html="pointThirteen" ref="incomingDef"></div>
                  <div v-html="pointFourTeen" ref="incomingDef"></div>
                  <div v-html="pointFifTeen" ref="incomingDef"></div>
                  <div v-html="pointSixTeen" ref="incomingDef"></div>
                  <div v-html="pointSevenTeen" ref="incomingDef"></div>
                  <div v-html="pointEigthTeen" ref="incomingDef"></div>
                  <div v-html="pointNineTeen" ref="incomingDef"></div>
                  <div v-html="pointTwenty" ref="incomingDef"></div>
                  <!-- <div class="vx-row">
                    <div class="vx-col w-full">{{ tituloIMG }}</div>
                    <vs-button
                      color="primary"
                      class="w-1/2 mt-5"
                      type="border"
                      icon-pack="feather"
                      icon="icon-next"
                      :disabled="arregloImgsCarro.length > 0 ? false : true"
                      v-on:click="antImg()"
                    >Anterior</vs-button>
                    <vs-button
                      color="primary"
                      class="w-1/2 mt-5"
                      type="border"
                      icon-pack="feather"
                      icon="icon-plus"
                      :disabled="arregloImgsCarro.length > 0 ? false : true"
                      v-on:click="sigImg()"
                    >Siguiente</vs-button>
                  </div> -->
                </div>
                <div class="vx-col md:w-full lg:w-1/2 w-full">
                  <h5>Detalles del vehículo</h5>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <div class="vx-row">
                        <div class="vx-col md:w-1/3">
                          <label for>Nombre del detalle</label>
                          <vs-input
                            v-model="namePoint"
                            class="w-full"
                            maxlength="250"
                            hint="Ingrese el nombre del detalle"
                          />
                        </div>
                        <div class="vx-col md:w-1/3">
                          <label for>Tipo de detalle</label>
                          <v-select
                            v-model="tipoAveriaID"
                            :options="tipoAverias"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          />
                        </div>
                        <div class="vx-col md:w-1/3">
                          <vs-button
                            color="success"
                            class="w-full mt-5"
                            type="border"
                            icon-pack="feather"
                            icon="icon-plus"
                            v-on:click="marketPoint()"
                            :disabled="arregloImgsCarro.length > 0 ? false : true"
                          >Agregar</vs-button>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full">
                      <hr class="my-3" />
                      <vs-table :data="pointsMarker" ref="table">
                        <template slot="thead">
                          <vs-th>NÚMERO</vs-th>
                          <vs-th>NOMBRE</vs-th>
                          <vs-th>TIPO</vs-th>
                          <vs-th>IMAGEN</vs-th>
                          <vs-th>OPT</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :data="items" :key="index" v-for="(items, index) in data">
                            <vs-td :data="data[index].Numero">{{data[index].Numero}}</vs-td>
                            <vs-td :data="data[index].Numero">{{data[index].Detalle}}</vs-td>
                            <vs-td :data="data[index].Numero">{{data[index].AveriaName}}</vs-td>
                            <vs-td>{{data[index].Nombre}}</vs-td>
                            <vs-td class="whitespace-no-wrap">
                              <feather-icon
                                icon="TrashIcon"
                                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2"
                                @click.stop="deletePoint(index)"
                              />
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </tab-content>

        <!-- tab 5 content -->
        <tab-content
          title="Firmas"
          class="mb-5"
          :before-change="validateStep5"
          v-if="ArrayFirmas.length > 0 ? true : false"
        >
          <div class="vx-row">
            <div class="vx-col w-full" :key="index" v-for="(item, index) in ArrayFirmas">
              <vx-card class="mb-5">
                <h5>{{ArrayFirmas[index].Nombre}}</h5>
                <div class="vx-row">
                  <div class="vx-col w-full mt-3">
                    <label for>Nombre</label>
                    <vs-input
                      v-model="ArrayFirmas[index].Firma.Nombre"
                      maxlength="50"
                      class="w-full"
                    />
                  </div>
                  <div class="vx-col w-full mt-3">
                    <label for>Firma</label>
                    <VueSignaturePad
                      :id="'signature'+ index"
                      class="signature_pad"
                      width="100%"
                      height="300px"
                      :ref="'signaturePad'"
                      :options="options"
                    />
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2 w-full mt-2">
                    <vs-button
                      type="border"
                      color="warning"
                      class="w-full"
                      v-on:click="undo(index)"
                    >Revertir</vs-button>
                  </div>
                  <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2 w-full mt-2">
                    <vs-button
                      type="border"
                      color="danger"
                      class="w-full"
                      v-on:click="Clear(index)"
                    >Borrar Todo</vs-button>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </tab-content>
      </form-wizard>
    </vs-popup>
  </vx-card>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
// import AgGridTable from "@/components/ag-grid-table/AgGridTable.vue";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import * as lang from "vuejs-datepicker/src/locale";
import $ from "jquery";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import authConfig from "@/../auth_config.json";

//const dict = FieldsValidate;

// register custom messages
//Validator.localize("en", dict);

export default {
  data() {
    return {
      //CAMPOS ACTIVADOS
      //STEP 1 CAMPOS HOJA INSPECCION
      fgCliente: { Campo: "Cliente", fgVisible: true },
      fgNombreCliente: { Campo: "Ayudante", fgVisible: true },
      fgTipoDocumento: { Campo: "TipoDocumento", fgVisible: true },
      fgTipoVehiculo: { Campo: "TipoVehiculo", fgVisible: true },
      fgVehiculo: { Campo: "Vehiculo", fgVisible: true },
      fgTipoChasis: { Campo: "TipoChasis", fgVisible: true },
      fgEstacion: { Campo: "Estacion", fgVisible: true },
      fgInspector: { Campo: "Inspector", fgVisible: true },
      fgContrato: { Campo: "Contrato", fgVisible: true },
      fgFactura: { Campo: "Factura", fgVisible: true },

      //STEP 2 CAMPOS HOJA RECEPCION
      fgFechaInicio: { Campo: "FechaInicio", fgVisible: true },
      fgFechaFinal: { Campo: "FechaFinal", fgVisible: true },
      fgkilometraje: { Campo: "kilometraje", fgVisible: true },
      fgObservaciones: { Campo: "Observaciones", fgVisible: true },

      //Datos generales
      HojaRID: 0,
      HojaIID: 0,
      HojasInspeccion: [],
      datos: {
        columnDefs: []
      },
      titlePopup: "",
      renderForm: true,
      fgReportes: true,
      popupActive: false,
      languages: lang,
      title: "Número de viajes marcado como tienda al mes",
      fcalendarEdit: new Date(),
      fcalendarFinal: new Date().setDate(new Date().getDate() + 1),
      renderComponents: true,
      fgVisibleLlanta: false,
      LsVehiculos: [],
      LsAllVehiculos: [],
      LsLlantas: [],
      CuestionarioEmpresa: {},
      selected: [],
      pointsMarker: [],
      arregloImgsCarro: [],
      disabledDates: {
        to: new Date(Date.now())
      },
      options: {
        penColor: "#000"
      },
      default: require("@/assets/images/vehiculos/default.png"),

      //Fields Step 1
      idCliente: 0,
      options1: [],
      Nombre: "",
      idTipoDocumento: 0,
      options2: [],
      idTipoChasis: 0,
      options3: [
        { id: 1, label: "CRAFTER C/CAJA" },
        { id: 2, label: "CRAFTER VAN" },
        { id: 3, label: "FL-360" },
        { id: 4, label: "FL-M2" },
        { id: 5, label: "HINO 300" },
        { id: 6, label: "HINO 500" },
        { id: 7, label: "HINO HIBRIDA" },
        { id: 8, label: "SPRINTER C/CAJA" },
        { id: 9, label: "SPRINTER VAN" },
        { id: 10, label: "UTILITARIO" }
      ],
      Contrato: "",
      Factura: "",
      idVehiculo: 0,
      options4: [],
      idTipoVehiculo: 0,
      TiposVehiculos: [],
      idEstacion: 0,
      options5: [],
      MarcaModelo: "",
      Descripcion: "",
      Placa: "",
      idEmpleado: 0,
      options6: [],

      //Fields Step 2
      options7: [
        { id: "Empty", label: "Empty" },
        { id: "1/16", label: "1/16" },
        { id: "1/8", label: "1/8" },
        { id: "3/16", label: "3/16" },
        { id: "1/4", label: "1/4" },
        { id: "5/16", label: "5/16" },
        { id: "3/8", label: "3/8" },
        { id: "7/16", label: "7/16" },
        { id: "1/2", label: "1/2" },
        { id: "9/16", label: "9/16" },
        { id: "5/8", label: "5/8" },
        { id: "11/16", label: "11/16" },
        { id: "3/4", label: "3/4" },
        { id: "13/16", label: "13/16" },
        { id: "7/8", label: "7/8" },
        { id: "15/16", label: "15/16" },
        { id: "Full", label: "Full" }
      ],
      optionsRutinas:[
        { id: "Empty", label: "Empty" }
      ],
      idCombustible: { id: "Empty", label: "Empty" },
      idRutina: { id: "Empty", label: "Empty" },
      idCombustibleLlegada: { id: "Empty", label: "Empty" }, //NUEVO
      idTipoCombustible: 0,
      options8: [],
      Kilometraje: "",
      KilometrajeEdicion: 0,
      KilometrajeFinal: "", //NUEVO
      litrosCargados: "", //NUEVO
      fLlegada: new Date(), //NUEVO
      fSalida: new Date(),
      time: new Date().getHours() + ":" + new Date().getMinutes(),
      timeLlegada: new Date().getHours() + ":" + new Date().getMinutes(), //NUEVO
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        dateFormat: "H:i"
      },
      Comentarios: "",

      //Step 4
      imgCarro: "",
      svgTest: null,
      py: 0,
      px: 0,
      valorimg: 0,
      tituloIMG: "FRONTAL",
      indiceCurrent: 0,
      image_width: 0,
      image_height: 0,
      indiceImg: 0,
      msjException: false,
      msjAlerta: "",
      namePoint: null,
      pointOne: null,
      pointTwo: null,
      pointThre: null,
      pointFor: null,
      pointFive: null,
      pointSix: null,
      pointSeven: null,
      pointEigth: null,
      pointNine: null,
      pointTen: null,
      pointEleven: null,
      pointTwelve: null,
      pointThirteen: null,
      pointFourTeen: null,
      pointFifTeen: null,
      pointSixTeen: null,
      pointSevenTeen: null,
      pointEigthTeen: null,
      pointNineTeen: null,
      pointTwenty: null,
      tipoAveriaID: 0,
      tipoAverias: [
        { id: 1, label: "RAYON" },
        { id: 2, label: "ABOLLADURA" },
        { id: 3, label: "DAÑO GENERICO" }
      ],

      //step5
      ArrayFirmas: [],

      //tabla servicios
      selectedTableServicios:[],//almacen los servicios selecccionados
      dataServicios: [],//almacena los servicios en pantalla
      dataServiciosFiltrados:[],
      serviciosFiltrados:false,
        idServicio:1,
        search:'',
        page: 1,
        elemetosPorPagina:15,
        totalPaginasServices:0,
        allCheck:false,
        dataServiciosOriginal:[],//almacena una copia de todos los servicios
        dataColumnsServices:[
          {
              "ServicioID":"ID",
              "Nombre":"NOMBRE",
              "TipoServicioNombre":"TIPO",
              "chequeado":"Checked"
          }
        ],
        activeBtn:1,
        checkRutinas:false,
        checkServicios:false,
        showRutinas:false,
        showServices:false,
        serviciosConsultados:false,
        textoTotalServicios:'',
        textoTotalServiciosSeleccionados:'',
        hojaResepcionEsPorRutina:false,
        serviciosSeleccionadosEnPantalla:false,
        respaldoServiciosEnPantalla:[],
        busquedaExacta:false
     
    };
  },
  components: {
    AgGridVue,
    Datepicker,
    FormWizard,
    "v-select": vSelect,
    TabContent,
    flatPickr
  },
  computed: {},
  watch: {
    fcalendarFinal(val) {
      let Inicio = new Date(this.fcalendarEdit);
      let Final = new Date(val);
      //console.log(new Date(val));
      if (Final < Inicio) {
        this.fcalendarEdit = this.fcalendarFinal;
      }
    },
    fcalendarEdit(val) {
      let Final = new Date(this.fcalendarFinal);
      let Inicio = new Date(val);

      if (Inicio > Final) {
        this.fcalendarFinal = this.fcalendarEdit;
      }
    },
    idVehiculo(val) {
       //alert("funk v");
      if (val != "") {
        const datosVehiculo = this.LsAllVehiculos.filter(vehiculo => {
          if (vehiculo.VehiculoID === val.id) {
            return vehiculo;
          }
        });

        this.fgVisibleLlanta = true;
        this.MarcaModelo =
          datosVehiculo[0].Marca + "-" + datosVehiculo[0].Modelo;
        this.Placa = datosVehiculo[0].Placa;
        this.idTipoCombustible = this.options8.filter(obj => {
          if (obj.id == datosVehiculo[0].TiposCombustible.ID) {
            return obj;
          }
        })[0];

        this.idTipoVehiculo = this.TiposVehiculos.filter(obj => {
          if (obj.id == datosVehiculo[0].TipoVehiculo.TipoVehiculoID) {
            return obj;
          }
        })[0];
        //this..estacionDuenia = datosVehiculo[0].Propietario.Nombre
        this.getLlantasVehiculo(datosVehiculo[0].VehiculoID);
        this.getUltimaHojaRecepcionByVehiculo(datosVehiculo[0])
      }
    },
    idTipoVehiculo(obj) {
      
      if (obj != null && obj != "" && obj.id > 0) {
        //alert(obj.id );
        this.arregloImgsCarro = [];
        if (this.HojaRID == 0) {
          this.pointsMarker = [];
        }
        let fgError = false;
        this.$vs.loading();

        if (obj.Fotos.length > 0) {
          for (var i in obj.Fotos) {
            if (obj.Fotos[i].Orden == 5) {
              this.arregloImgsCarro.push({
                img: obj.Fotos[i].ImagenUrl,
                indice: obj.Fotos[i].Orden,
                id: obj.Fotos[i].TipoVehiculoFotoID,
                titulo:
                  obj.Fotos[i].Orden == 1
                    ? "FRONTAL"
                    : obj.Fotos[i].Orden == 2
                    ? "TRASERA"
                    : obj.Fotos[i].Orden == 3
                    ? "LATERAL DER"
                    : "LATERAL IZQ",
                TipoVehiculoID: obj.Fotos[i].TipoVehiculoID
              });
            }
          }
        } else {
          fgError = true;
        }

        if (this.arregloImgsCarro.length == 0) {
          fgError = true;
        } else {
          this.imgCarro = this.arregloImgsCarro[0].img;
        }

        if (fgError) {
          this.$vs.notify({
            color: "danger",
            time: 15000,
            title: "Alerta",
            text:
              "El tipo de vehículo " +
              obj.label +
              " no tiene imágenes de detalles del vehículo asignados."
          });

          this.imgCarro = this.default;
        }
        this.getVehiculosByTipo(obj.id);
        this.getRutinasByTipoVehiculo(obj);
        this.getCuestionario(obj);
        //this.getVehiculosByTipo(obj.id); //
        setTimeout(() => {
          this.$vs.loading.close();
        }, 500);
      }
    },
    // HojaIID(obj) {
    //   // if (obj != null && obj.id > 0) {
    //   //   this.$vs.loading();
    //   //   setTimeout(() => {
    //   //     this.getHojaInformation(obj.id); //
    //   //     this.$vs.loading.close();
    //   //   }, 1000);
    //   // } else {
    //   //   this.clearForm();
    //   // }
    // },
    
    Kilometraje(New) {
      this.Kilometraje =
        parseFloat(New) > 0
          ? New.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",")
          : "";
    },
    KilometrajeFinal(New) {
      this.KilometrajeFinal =
        parseFloat(New) > 0
          ? New.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",")
          : "";
    },
    litrosCargados(New) {
      this.litrosCargados =
        parseFloat(New) > 0
          ? New.replace(/\D/g, "")
              .replace(/([0-9])([0-9]{2})$/, "$1.$2")
              .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",")
          : "";
    },
    popupActive(fg) {
      if (fg === false) {
        //alert("limpiar");
        this.clearForm();
        setTimeout(() => {
          this.$vs.loading.close();
        }, 500);
      }
      this.errors.clear();
    }
  },
  created() {
    if (authConfig.EmpresaId > 0) {
      this.getCamposHojaInspeccion();
      this.getCamposFirmas();
    } else {
      this.$router.push({ path: "/" });
    }

  },
  mounted() {
    
    this.getClientes();
    this.getSucursales();
    this.getTiposVehiculos();
    this.getVehiculos();
    this.getEmpleados();
    //this.getCuestionario();
    this.getTipoDocumentos();
    this.getHojasInspeccion();
    this.getTiposCombustible();
    this.getFolioHojaRecepcion();
    //this.getRespaldoServices();
  },
  beforeMount() {
    setTimeout(() => {
      this.searchRecepcion();
    }, 500);
    this.forceRerender();
    //this.loadSignatures();
  },
  methods: {
    //Signature PAD
    undo(index) {
      this.$refs.signaturePad[index].undoSignature();
      const { isEmpty, data } = this.$refs.signaturePad[index].saveSignature();

      if (!isEmpty) {
        this.ArrayFirmas[index].Firma.Firma = data;
      } else {
        this.ArrayFirmas[index].Firma.Firma = null;
      }
      //this.loadSignatures();
    },
    Clear(index) {
      this.$refs.signaturePad[index].clearSignature();
      this.ArrayFirmas[index].Firma.Firma = null;
    },
    //==============
    forceRerender() {
      this.renderComponents = false;

      this.$nextTick(() => {
        this.renderComponents = true;
      });
    },
    clearForm() {
      this.HojaRID = 0;
      this.errors.clear();
      this.$refs.wizard.navigateToTab(0);
      //console.log("limpieza!!");
      //console.log(this.HojaIID);
      //this.$refs.wizard.Reset();
      //if (this.HojaIID != null && this.HojaIID.id > 0)
      let limpiar=true;
      if (limpiar) {
        if (this.ArrayFirmas.length > 0) {
          for (var i in this.ArrayFirmas) {
            this.$refs.signaturePad[i].clearSignature();
            this.ArrayFirmas[i].Firma.Firma = null;
            this.ArrayFirmas[i].Firma.Nombre = null;
            this.ArrayFirmas[i].Firma.FirmaReporteID = 0;
            this.ArrayFirmas[i].Firma.HojaInspeccionID = null;
            this.ArrayFirmas[i].Firma.HojaRecepcionID = null;
          }
        }
        this.HojaIID = null;
        this.errors.clear();
        this.KilometrajeEdicion = 0;
        this.idCliente = this.fgCliente.fgVisible ? "" : "Empty";
        this.Nombre = this.fgNombreCliente.fgVisible ? "" : "Empty";
        this.idTipoDocumento = this.fgTipoDocumento.fgVisible
          ? ""
          : { id: 0, label: "" };
        this.idTipoChasis = this.fgTipoChasis.fgVisible
          ? ""
          : { id: 0, label: "" };
        this.Contrato = this.fgContrato.fgVisible ? "" : "Empty";
        this.Factura = this.fgFactura.fgVisible ? "" : "Empty";
        this.idVehiculo = this.fgVehiculo.fgVisible ? "" : { id: 0, label: "" };
        this.idTipoVehiculo = this.fgTipoVehiculo.fgVisible
          ? ""
          : { id: 0, label: "" };
        this.idEstacion = this.fgEstacion.fgVisible ? "" : { id: 0, label: "" };
        this.Descripcion = "";
        this.MarcaModelo = "";
        this.idEmpleado = this.fgInspector.fgVisible
          ? ""
          : { id: 0, label: "" };
        this.Placa = "";
        this.LsLlantas = [];
        this.fgVisibleLlanta = false;
        this.idTipoCombustible = this.options8[0];
        this.Kilometraje = this.fgkilometraje.fgVisible ? "" : 0;
        (this.fSalida = new Date()),
          (this.fLlegada = new Date()),
          (this.time = new Date().getHours() + ":" + new Date().getMinutes()),
          this.errors.clear();
        this.Comentarios = "";
        this.selected = [];
        this.imgCarro = "";
        this.svgTest = null;
        this.py = 0;
        this.px = 0;
        this.valorimg = 0;
        this.tituloIMG = "FRONTAL";
        this.indiceCurrent = 0;
        this.image_width = 0;
        this.image_height = 0;
        this.indiceImg = 0;
        this.msjException = false;
        this.msjAlerta = "";
        this.namePoint = null;
        this.pointOne = null;
        this.pointTwo = null;
        this.pointThre = null;
        this.pointFor = null;
        this.pointFive = null;
        this.pointSix = null;
        this.pointSeven = null;
        this.pointEigth = null;
        this.pointNine = null;
        this.pointTen = null;
        this.pointEleven = null;
        this.pointTwelve = null;
        this.pointThirteen = null;
        this.pointFourTeen = null;
        this.pointFifTeen = null;
        this.pointSixTeen = null;
        this.pointSevenTeen = null;
        this.pointEigthTeen = null;
        this.pointNineTeen = null;
        this.pointTwenty = null;
        this.tipoAveriaID = null;
        this.pointsMarker = [];
        this.getResetItemsbyTable();
        this.$refs.wizard.navigateToTab(0);
      }
    },
    ActivePopup() {
      this.titlePopup =
        this.HojaRID > 0
          ? "Editar hoja de recepción vehícular"
          : "Agregar hoja de recepción vehícular";
      this.popupActive = true;
      this.forceRerenderForm();
    },
    filterInputDecimals(tipo) {
      switch (parseInt(tipo)) {
        case 1:
          //this.Kilometraje = this.Kilometraje.replace(/[0-9]+(\.[0-9][0-9]?)?/g, "")
          break;
        case 2:
          //this.KilometrajeFinal = this.KilometrajeFinal.replace(/[^0-9]+/g, "")
          break;
        case 3:
          //this.litrosCargados = this.litrosCargados.replace(/[^0-9]+/g, "")
          break;
      }
      tipo == 3 ? this.Kilometraje.replace(/[^0-9]+/g, "") : this.Kilometraje;
    },
    marketPoint() {
      const vm = this;
      const noPoints = vm.pointsMarker.length;
      if (vm.namePoint == null) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "Alerta",
          text: "Ingrese el nombre del detalle encontrado"
        });
        return;
      }

      if (vm.tipoAveriaID == null) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "Alerta",
          text: "seleccione el tipo de detalle"
        });
        return;
      }

      if (vm.px === 0 || vm.py === 0) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "Alerta",
          text: "seleccione una ubicación válida"
        });
        return;
      }
      for (let i = 0; i < vm.pointsMarker.length; i++) {
        if (vm.pointsMarker[i].Detalle === vm.namePoint) {
          this.$vs.notify({
            time: 5000,
            color: "danger",
            title: "Alerta",
            text: "Ya existe un punto con el nombre: " + vm.namePoint
          });
          return; //
        }
      }
      // let tipoID = vm.tipoAverias.filter(item => {
      //   if (item.id === vm.tipoAveriaID.id) {
      //     return item.id;
      //   }
      // });
      //console.log(vm.arregloImgsCarro[vm.indiceCurrent]);

      vm.pointsMarker.push({
        AveriaID: 0,
        Numero: noPoints + 1,
        Detalle: vm.namePoint,
        EjeX: vm.px,
        EjeY: vm.py,
        ImagenID: vm.arregloImgsCarro[vm.indiceCurrent].id,
        TipoAveria: vm.tipoAveriaID.id,
        Nombre: vm.arregloImgsCarro[vm.indiceCurrent].titulo,
        AveriaName: vm.tipoAveriaID.label
      });
      vm.namePoint = "";
      vm.paintPoints();
      vm.tipoAveriaID = [];
      vm.px = 0;
      vm.py = 0;
    },
    deletePoint(index) {
      //console.log(index);
      //return;

      let vm = this;
      vm.pointsMarker.splice(index, 1);
      vm.pointOne = "";
      vm.pointTwo = "";
      vm.pointThre = "";
      vm.pointFor = "";
      vm.pointFive = "";
      vm.pointSix = "";
      vm.pointSeven = "";
      vm.pointEigth = "";
      vm.pointNine = "";
      vm.pointTen = "";
      vm.pointEleven = "";
      vm.pointTwelve = "";
      vm.pointThirteen = "";
      vm.pointFourTeen = "";
      vm.pointFifTeen = "";
      vm.pointSixTeen = "";
      vm.pointSevenTeen = "";
      vm.pointEigthTeen = "";
      vm.pointNineTeen = "";
      vm.pointTwenty = "";
      vm.paintPoints();
    },
    antImg() {
      const vm = this;
      vm.svgTest = null;
      const indice = vm.indiceCurrent - 1;
      if (indice <= 0) {
        vm.imgCarro = vm.arregloImgsCarro[0].img;
        vm.indiceImg = vm.arregloImgsCarro[0].id;
        vm.indiceCurrent = 0;
        vm.tituloIMG = vm.arregloImgsCarro[0].titulo;
      } else {
        vm.imgCarro = vm.arregloImgsCarro[indice].img;
        vm.indiceImg = vm.arregloImgsCarro[indice].id;
        vm.indiceCurrent = vm.indiceCurrent - 1;
        vm.tituloIMG = vm.arregloImgsCarro[indice].titulo;
      }
      vm.pointOne = "";
      vm.pointTwo = "";
      vm.pointThre = "";
      vm.pointFor = "";
      vm.pointFive = "";
      vm.pointSix = "";
      vm.pointSeven = "";
      vm.pointEigth = "";
      vm.pointNine = "";
      vm.pointTen = "";
      vm.pointEleven = "";
      vm.pointTwelve = "";
      vm.pointThirteen = "";
      vm.pointFourTeen = "";
      vm.pointFifTeen = "";
      vm.pointSixTeen = "";
      vm.pointSevenTeen = "";
      vm.pointEigthTeen = "";
      vm.pointNineTeen = "";
      vm.pointTwenty = "";
      vm.paintPoints();
    },
    sigImg() {
      const vm = this;
      vm.svgTest = null;
      const indice = vm.indiceCurrent + 1;
      const noImgs = vm.arregloImgsCarro.length - 1;
      if (indice >= noImgs) {
        vm.imgCarro = vm.arregloImgsCarro[noImgs].img;
        vm.indiceImg = vm.arregloImgsCarro[noImgs].id;
        vm.indiceCurrent = noImgs;
        vm.tituloIMG = vm.arregloImgsCarro[noImgs].titulo;
      } else {
        vm.imgCarro = vm.arregloImgsCarro[indice].img;
        vm.indiceImg = vm.arregloImgsCarro[noImgs].id;
        vm.indiceCurrent = vm.indiceCurrent + 1;
        vm.tituloIMG = vm.arregloImgsCarro[indice].titulo;
      }
      vm.pointOne = "";
      vm.pointTwo = "";
      vm.pointThre = "";
      vm.pointFor = "";
      vm.pointFive = "";
      vm.pointSix = "";
      vm.pointSeven = "";
      vm.pointEigth = "";
      vm.pointNine = "";
      vm.pointTen = "";
      vm.pointEleven = "";
      vm.pointTwelve = "";
      vm.pointThirteen = "";
      vm.pointFourTeen = "";
      vm.pointFifTeen = "";
      vm.pointSixTeen = "";
      vm.pointSevenTeen = "";
      vm.pointEigthTeen = "";
      vm.pointNineTeen = "";
      vm.pointTwenty = "";
      vm.paintPoints();
    },
    getCordenadas(event) {
      const vm = this;
      const i = document.querySelector("#img-element"); //$("#img-element");
      vm.image_width = i.offsetWidth;
      vm.image_height = i.offsetHeight;
      window.ev = event;
      vm.px = event.offsetX + 11;
      vm.py = event.offsetY + 23;
      //console.log(event.offsetX + " _ " + event.offsetY);
      vm.svgTest = null;
      const newSvg = `<svg width="100%" id="punto-defectiva" height="100%" style="position: absolute; left: 0px; top: 0px;pointer-events: none; z-index: 1000">
                         <g>
                           <circle cx="${vm.px}" cy="${vm.py}" z="5" r="10" stroke="#f0ab00" stroke-width="4" fill="#f0ab00" />
                           </circle>
                           <text x="${vm.px}" y="${vm.py}" text-anchor="middle" color="white" alignment-baseline="central" fill="black">
                               Point
                            </text>
                         </g>
                      </svg>`;

      vm.svgTest = newSvg;
      /* if (TweenMax.isTweening(vm.$refs.incomingDef)) {
        TweenMax.killTweensOf(vm.$refs.incomingDef)
        vm.$refs.incomingDef.style.opacity = '1'
      }
      TweenMax.to(vm.$refs.incomingDef, 0.5, { opacity: 0.3, repeat: -1, yoyo: true }) */
    },
    paintPoints() {
      const vm = this;
      let colorPoint = "";
      //console.log(this.pointsMarker);
      for (let i = 0; i < vm.pointsMarker.length; i++) {
        var tipoAveria = vm.pointsMarker[i].AveriaName;
        if (tipoAveria == "RAYON") {
          colorPoint = "#baf1a1";
        } else if (tipoAveria == "ABOLLADURA") {
          colorPoint = "#ea728c";
        } else {
          colorPoint = "#459CD2";
        }
        vm.indiceImg = this.arregloImgsCarro.filter(obj => {
          if (obj.id == vm.pointsMarker[i].ImagenID) {
            return obj;
          }
        })[0].id;

        if (
          vm.pointsMarker[i].ImagenID ===
          this.arregloImgsCarro[vm.indiceCurrent].id
        ) {
          //
          const newSvg = `<svg width="100%" id="punto-defectiva" height="100%" style="position: absolute; left: 0px; top: 0px;pointer-events: none; z-index: 1000">
                         <g>
                           <circle cx="${vm.pointsMarker[i].EjeX}" cy="${vm.pointsMarker[i].EjeY}" z="5" r="10" stroke="${colorPoint}" stroke-width="4" fill="${colorPoint}" />
                           </circle>
                           <text x="${vm.pointsMarker[i].EjeX}" y="${vm.pointsMarker[i].EjeY}" text-anchor="middle" color="white" alignment-baseline="central" fill="black">
                               ${vm.pointsMarker[i].Numero}
                            </text>
                         </g>
                      </svg>`;

          switch (vm.pointsMarker[i].Numero) {
            case 1:
              vm.pointOne = newSvg;
              break;
            case 2:
              vm.pointTwo = newSvg;
              break;
            case 3:
              vm.pointThre = newSvg;
              break;
            case 4:
              vm.pointFor = newSvg;
              break;
            case 5:
              vm.pointFive = newSvg;
              break;
            case 6:
              vm.pointSix = newSvg;
              break;
            case 7:
              vm.pointSeven = newSvg;
              break;
            case 8:
              vm.pointEigth = newSvg;
              break;
            case 9:
              vm.pointNine = newSvg;
              break;
            case 10:
              vm.pointTen = newSvg;
              break;
            case 11:
              vm.pointEleven = newSvg;
              break;
            case 12:
              vm.pointTwelve = newSvg;
              break;
            case 13:
              vm.pointThirteen = newSvg;
              break;
            case 14:
              vm.pointFourTeen = newSvg;
              break;
            case 15:
              vm.pointFifTeen = newSvg;
              break;
            case 16:
              vm.pointSixTeen = newSvg;
              break;
            case 17:
              vm.pointSevenTeen = newSvg;
              break;
            case 18:
              vm.pointEigthTeen = newSvg;
              break;
            case 19:
              vm.pointNineTeen = newSvg;
              break;
            case 20:
              vm.pointTwenty = newSvg;
              break;
          }
        }
      }
    },
    searchRecepcion() {
      const vm = this;
      const parametros = {};

      //vm.Detalle_Tabla = []
      /* if (vm.noInspeccion === null || vm.noInspeccion === '' || vm.noInspeccion === 0 || isNaN(vm.noInspeccion) === true) {
        vm.msjException = true
        vm.msjAlerta = 'Ingrese un número de inspección válido'
        return false
      } */
      if (vm.fcalendarEdit === null || vm.fcalendarFinal === null) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "Alerta",
          text: "Ingrese un rango de fechas valido"
        });

        return false;
      }
      parametros.feInicio =
        new Date(vm.fcalendarEdit).getFullYear() +
        "-" +
        (new Date(vm.fcalendarEdit).getMonth() + 1) +
        "-" +
        new Date(vm.fcalendarEdit).getDate();
      parametros.feFin =
        new Date(vm.fcalendarFinal).getFullYear() +
        "-" +
        (new Date(vm.fcalendarFinal).getMonth() + 1) +
        "-" +
        new Date(vm.fcalendarFinal).getDate();
      parametros.EmpresaID = authConfig.EmpresaId;
      parametros.ID = 2; //this.$route.query.Id;
      //      vm.overlay = true
      //vm.Api + "/api/HojaInspeccion/GetByRango"
      //
      $.ajax({
        url: vm.WS + "/Checklist/GetByRango",
        type: "POST",
        dataType: "Json",
        async: false,
        data: parametros,
        success: res => {
          // this.datos.gridOptions = {};
          // this.datos.columnDefs = [];
          // this.datos.defaultColDef = {
          //   editable: false
          // };
          // this.datos.gridApi = null;
          this.datos = res.Data;
          //     //this.forceRerender();
          // }
        }
      });

      this.forceRerender();
      this.validateColumns();
    },
    validateColumns() {
      this.datos.columnDefs = [];
      if (this.datos.json.length > 0) {
        this.datos.columnDefs = [
          { headerName: "FOLIO", field: "NO", width: 100, sortable: true, },
        ];
         if (this.fgVehiculo.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "VEHÍCULO",
            field: "VEHICULO",
            width: 150
          });
        }
        if (this.fgCliente.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "CLIENTE",
            field: "CLIENTE",
            width: 350
          });
        }

        // this.datos.columnDefs.push({
        //   headerName: "INSPECCIÓN",
        //   field: "INSPECCION",
        //   width: 250
        // });
        this.datos.columnDefs.push({
          headerName: "F. INICIO",
          field: "FECHAI",
          width: 250
        });
        this.datos.columnDefs.push({
          headerName: "F. FIN",
          field: "FECHAF",
          width: 250
        });
        this.datos.columnDefs.push({
          headerName: "INSPECCIÓN",
          field: "INSPECCION",
          width: 250
        });

        // if (this.fgCliente.fgVisible) {
        //   this.datos.columnDefs.push({
        //     headerName: "CLIENTE",
        //     field: "CLIENTE",
        //     width: 350
        //   });
        // }

        if (this.fgContrato.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "CONTRATO",
            field: "CONTRATO",
            width: 200
          });
        }

        // if (this.fgVehiculo.fgVisible) {
        //   this.datos.columnDefs.push({
        //     headerName: "VEHÍCULO",
        //     field: "VEHICULO",
        //     width: 300
        //   });
        // }

        if (this.fgTipoVehiculo.fgVisible) {
          this.datos.columnDefs.push({
            headerName: "TIPO DE VEHÍCULO",
            field: "TIPOVEHICULO",
            width: 350
          });
        }

        // if(this.fgTipoChasis.fgVisible){
        //   this.datos.columnDefs.push({
        //     headerName: "TIPO DE CHASIS",
        //     width: 350,
        //     cellRenderer: function boton(params) {
        //       return options3.filter(item => {
        //         if(item.id == params.data.)
        //       });
        //     }
        //   })
        // }

        this.datos.columnDefs.push({
          headerName: "KM",
          field: "KM",
          width: 200
        });

        this.datos.columnDefs.push({
          headerName: "OBSERVACIONES",
          field: "OBSERVACIONES",
          width: 200
        });

        this.datos.columnDefs.push({
          headerName: "",
          filter: false,
          width: 100,
          pinned: "right",
          cellRenderer: function boton(params) {
            return (
              `<i class="feather icon-edit-2 editar" @click="this.editRecepcion(` +
              params.data.NO +
              `)" style="font-size: 24px;cursor: pointer" title="Editar"></i>`
            );
          },
          onCellClicked: params => {
            this.editRecepcion(params.data.ID);
          }
        });
        this.datos.columnDefs.push({
          headerName: "",
          filter: false,
          width: 100,
          pinned: "right",
          cellRenderer: function boton() {
            return `<i class="feather icon-printer imprimir" style="font-size: 24px;cursor: pointer" title="Imprimir"></i>`;
          },
          onCellClicked: params => {
            this.imprimirRecepcion(params.data.ID);
          }
        });
        // {
        //   headerName: "",
        //   filter: false,
        //   width: 100,
        //   pinned: "right",
        //   cellRenderer: function boton(params) {
        //     return `<i class="feather icon-printer imprimir" style="font-size: 24px;cursor: pointer" title="Imprimir"></i>`;
        //   },
        //   onCellClicked: function(params) {
        //     console.log(params.data);
        //   }
        // }
      }
    },
    getHojaInformation(x) {
      const vm = this;
      if (vm.HojaRID == 0) {
        vm.selected = [];
        vm.pointsMarker = [];
      }
      vm.banderaEdit = 1;
      vm.overlay = true;
      $.ajax({
        url: this.WS + "/Checklist/getHojaInspeccionById",
        type: "POST",
        dataType: "Json",
        data: { ID: x },
        async: false,
        success: res => {
          if (res.Estatus == -1) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: "Ocurrió un error inesperado, favor de intentarlo de nuevo."
            });

            return;
          } else if (res.Estatus == 0) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: res.Mensaje
            });

            return;
          }

          this.idCliente = vm.fgCliente.fgVisible
            ? vm.options1.filter(item => {
                if (item.id == res.Data.ClienteID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          this.Nombre = vm.fgNombreCliente.fgVisible
            ? res.Data.NombreCliente
            : "Empty";
          this.idTipoDocumento = vm.fgTipoDocumento.fgVisible
            ? vm.options2.filter(item => {
                if (item.id == res.Data.TipoInspeccion) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          this.idTipoChasis = vm.fgTipoChasis.fgVisible
            ? vm.options3.filter(item => {
                if (item.id == res.Data.TipoChasisID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          this.Contrato = vm.fgContrato.fgVisible ? res.Data.Contrato : "Empty";
          this.Factura = vm.fgFactura.fgVisible ? res.Data.Factura : "Empty";
          this.idTipoVehiculo = vm.fgTipoVehiculo.fgVisible
            ? vm.TiposVehiculos.filter(item => {
                if (item.id == res.Data.TipoVehiculoID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          setTimeout(() => {
            //console.log(vm.options4);
            this.idVehiculo = vm.fgVehiculo.fgVisible
              ? vm.options4.filter(item => {
                  if (item.id == res.Data.VehiculoID) {
                    return item;
                  }
                })[0]
              : { id: 0, label: "" };
          }, 500);
          this.idEstacion = vm.fgEstacion.fgVisible
            ? vm.options5.filter(item => {
                if (item.label == res.Data.Estacion) {
                  return item;
                }

                if (item.id === res.Data.Estacion) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          this.idEmpleado = vm.fgInspector.fgVisible
            ? vm.options6.filter(item => {
                if (item.id == res.Data.InspectorID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
        }
      });
    },
    editRecepcion(x) {
      const vm = this;
      vm.selected = [];
      vm.pointsMarker = [];
      vm.banderaEdit = 1;
      vm.overlay = true;
      $.ajax({
        url: this.WS + "/Checklist/getHojaRecepcionById",
        type: "POST",
        dataType: "Json",
        data: { ID: x },
        async: false,
        success: res => {
          if (res.Estatus == -1) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: "Ocurrió un error inesperado, favor de intentarlo de nuevo."
            });

            return;
          } else if (res.Estatus == 0) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: res.Mensaje
            });

            return;
          }

          this.Comentarios = vm.fgObservaciones.fgVisible
            ? res.Data.TrabajoRealizar
            : "Empty";
          this.idTipoCombustible = vm.options8.filter(item => {
            if (item.id === res.Data.TipoCombustibleID) {
              return item;
            }
          })[0];

          this.idCombustible = vm.options7.filter(item => {
            if(item.id == res.Data.Combustible){
              return item;
            }
          })[0];

          //rutinas

           this.idRutina = vm.optionsRutinas.filter(item => {
            if(item.id == res.Data.RutinaID){
              return item;
            }
          })[0];

          if(res.Data.EsPorRutina){
            this.hojaResepcionEsPorRutina=true;
            this.checkRutinas=true;
            this.checkServicios=false;
            this.showRutinas=true;
            this.serviciosConsultados=false;
            this.allCheck=false;
          }else{
             this.allCheck=true;
            this.hojaResepcionEsPorRutina=false;
            this.checkRutinas=false;
            this.checkServicios=true;
            this.showRutinas=false;
            this.showServices=true;
            this.selectedTableServicios=[];
            this.dataServicios=[];
            this.dataServiciosOriginal=[];
            let serviciosSelectEdit=[];
            this.dataServiciosOriginal=res.Data.ServiciosSeleccionados;
            serviciosSelectEdit=res.Data.ServiciosSeleccionados.filter(p=>p.chequeado===true);
            this.selectedTableServicios=serviciosSelectEdit;
            this.dataServicios=serviciosSelectEdit;
            this.serviciosConsultados=true;
            this.getEstatusTextosServicios();
            // res.Data.ServiciosSeleccionados.forEach(servSel=>{
            //    if(item.chequeado){
            //         this.selectedTableServicios.push({ServicioID:item.ServicioID,Nombre:item.Nombre,
            //                                             TipoServicioID:item.TipoServicioID,EmpresaID:item.EmpresaID,
            //                                             TipoServicioNombre:item.TipoServicioNombre,chequeado:item.chequeado});
            //       }
            // })
          }

          //

          //TipoVehiculos y vehiculos
          this.idTipoVehiculo = vm.fgTipoVehiculo.fgVisible
            ? vm.TiposVehiculos.filter(item => {
                if (item.id == res.Data.TipoVehiculoID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
            //this.idTipoVehiculo.watch()

            //this.idTipoVehiculo(this.idTipoVehiculo);
             
          setTimeout(() => {
            //console.log(vm.options4);
            this.idVehiculo = vm.fgVehiculo.fgVisible
              ? vm.options4.filter(item => {
                  if (item.id == res.Data.VehiculoID) {
                    return item;
                  }
                })[0]
              : { id: 0, label: "" };
             // this.idVehiculo(this.idVehiculo);
          }, 500);
          //fin

          this.Kilometraje = vm.fgkilometraje.fgVisible
            ? parseFloat(res.Data.Kilometraje).FormatMiles()
            : 0;
          this.KilometrajeEdicion = res.Data.Kilometraje;
          this.fSalida = vm.fgFechaInicio.fgVisible
            ? new Date(res.Data.FechaInicio)
            : new Date();
          this.fLlegada = vm.fgFechaFinal.fgVisible
            ? new Date(res.Data.FechaFin)
            : new Date();

          this.HojaIID = {
            id: res.Data.HojaInspeccionID,
            label: "No. " + res.Data.HojaInspeccionID
          };
          //setTimeout(() => {},500);
          
          const infoAverias = res.Data.Averias;
          setTimeout(() => {
          for (let i = 0; i < infoAverias.length; i++) {
            const tipoAveriaName = vm.tipoAverias.filter(item => {
              if (item.id === infoAverias[i].TipoAveria) {
                return item;
              }
            });
            vm.pointsMarker.push({
              AveriaID: infoAverias[i].AveriaID,
              Numero: infoAverias[i].Numero,
              Detalle: infoAverias[i].Detalle,
              EjeX: infoAverias[i].EjeX,
              EjeY: infoAverias[i].EjeY,
              ImagenID: infoAverias[i].ImagenID,
              TipoAveria: tipoAveriaName[0].id,
              Nombre: vm.arregloImgsCarro.filter(item => {
                if (item.id === infoAverias[i].ImagenID) {
                  return item;
                }
              })[0].titulo,
              AveriaName: tipoAveriaName[0].label
            });
          }
          },500);
          setTimeout(() => {
          for (let i = 0; i < res.Data.Cuestionario.length; i++) {
            //let cuestionarioEmpresaSeccioneslength=vm.CuestionarioEmpresa.Secciones!=null?vm.CuestionarioEmpresa.Secciones.length:0;
            //vm.CuestionarioEmpresa.Secciones.length
            
            for (let x = 0; x < vm.CuestionarioEmpresa.Secciones.length; x++) {
              for (
                let y = 0;
                y < vm.CuestionarioEmpresa.Secciones[x].Preguntas.length;
                y++
              ) {
                if (
                  vm.CuestionarioEmpresa.Secciones[x].Preguntas[y]
                    .PreguntaID === res.Data.Cuestionario[i].PreguntaID
                ) {
                  //
                  vm.selected.push(
                    vm.CuestionarioEmpresa.Secciones[x].Preguntas[y]
                  );
                }
              }
            }
          }
          },500);
          this.idCliente = vm.fgCliente.fgVisible
            ? vm.options1.filter(item => {
                if (item.id == res.Data.ClienteID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          this.Nombre = vm.fgNombreCliente.fgVisible
            ? res.Data.NombreCliente
            : "Empty";
          this.idTipoDocumento = vm.fgTipoDocumento.fgVisible
            ? vm.options2.filter(item => {
                if (item.id == res.Data.TipoDocumentoID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          this.idTipoChasis = vm.fgTipoChasis.fgVisible
            ? vm.options3.filter(item => {
                if (item.id == res.Data.TipoChasisID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          this.Contrato = vm.fgContrato.fgVisible ? res.Data.Contrato : "Empty";
          this.Factura = vm.fgFactura.fgVisible ? res.Data.Factura : "Empty";
          // this.idTipoVehiculo = vm.fgTipoVehiculo.fgVisible
          //   ? vm.TiposVehiculos.filter(item => {
          //       if (item.id == res.Data.TipoVehiculoID) {
          //         return item;
          //       }
          //     })[0]
          //   : { id: 0, label: "" };
          // setTimeout(() => {
          //   //console.log(vm.options4);
          //   this.idVehiculo = vm.fgVehiculo.fgVisible
          //     ? vm.options4.filter(item => {
          //         if (item.id == res.Data.VehiculoID) {
          //           return item;
          //         }
          //       })[0]
          //     : { id: 0, label: "" };
          // }, 500);
          this.idEstacion = vm.fgEstacion.fgVisible
            ? vm.options5.filter(item => {
                if (item.label == res.Data.Estacion) {
                  return item;
                }

                if (item.id === res.Data.Estacion) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };
          this.idEmpleado = vm.fgInspector.fgVisible
            ? vm.options6.filter(item => {
                if (item.id == res.Data.InspectorID) {
                  return item;
                }
              })[0]
            : { id: 0, label: "" };

          this.HojaRID = x;
          //console.log("verificar get => " + this.HojaRID);
          vm.ActivePopup();

          if (this.ArrayFirmas.length > 0) {
            if (res.Data.Firmas != null && res.Data.Firmas.length > 0) {
              this.ArrayFirmas = res.Data.Firmas;
              this.options.onBegin = () => {};
              //console.log(this.ArrayFirmas);
              // for (var index in this.ArrayFirmas) {
              //   //this.$nextTick(() => {
              //     this.$refs.signaturePad[index].resizeCanvas();
              //     const { isEmpty, data } = this.$refs.signaturePad[
              //       index
              //     ].saveSignature();
              //     this.$refs.signaturePad[index].fromDataURL(
              //       this.ArrayFirmas[index].Firma.Firma
              //     );
              //   //});
              // }
            }
          }

          vm.paintPoints();
          
        }
      });
    },
    imprimirRecepcion(x) {
      var parameters = { idHoja: x };
      window.location.href =
        this.WS +
        "/Checklist/ImprimirRecepcion?json=" +
        JSON.stringify(parameters);
    },
    handleValidation: function(isValid, tabIndex) {
      //console.log(this);
      //console.log(isValid);
      //console.log(tabIndex);
      if (tabIndex == 4) {
        this.loadSignatures();
        setTimeout(() => {
          this.loadSignatures();
        }, 1000);
      }
    },
    loadSignatures() {
      if (this.ArrayFirmas.length > 0) {
        // this.$nextTick(() => {
        //   this.$refs.signaturePadp.resizeCanvas();
        //   //ref.resizeCanvas();
        // });
        //console.log(this.HojaRID);
        //this.$refs.signaturePad.lockSignaturePad()
        $.each(this.$refs.signaturePad, (i) => {
          this.$nextTick(() => {
            this.$refs.signaturePad[i].resizeCanvas();
            //ref.resizeCanvas();
          });
          if (this.HojaRID > 0) {
            //console.log(this.ArrayFirmas[i].Firma.Firma);
            
            this.$refs.signaturePad[
              i
            ].saveSignature();

            this.$refs.signaturePad[i].fromDataURL(
              this.ArrayFirmas[i].Firma.Firma
            );
            //console.log(isEmpty)
            //console.log(data)            
          }
        });
      }
    },
    formSubmitted() {
      this.saveInformacion();
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1").then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1").then(result => {
          if (result) {
            //alert("aqui estoy");
            let vm = this;
            let validateOdometro = {};
            let kSalida = parseFloat(this.KilometrajeEdicion);
            let KFinal = parseFloat(
              this.Kilometraje != null
                ? this.Kilometraje.split(",").join("")
                : this.Kilometraje
            );

            if (this.HojaRID > 0) {
              if (KFinal < kSalida) {
                this.$vs.notify({
                  time: 5000,
                  color: "danger",
                  title: "Alerta",
                  text:
                    "El kilometraje de llegada no puede ser menor al de salida."
                });

                setTimeout(() => {
                  this.$vs.loading.close();
                }, 500);
                reject("correct all values");
              } else if (KFinal >= kSalida) {
                if (KFinal > kSalida) {
                  this.$vs.loading();
                  let UOdometro = {
                    VehiculoID: this.idVehiculo.id,
                    Odometro: KFinal,
                    LongitudID: 1
                  };
                  $.ajax({
                    url: this.Api + "/api/Vehiculo/ValidateOdometro",
                    type: "POST",
                    dataType: "Json",
                    async: false,
                    data: UOdometro,
                    success: res => {
                      validateOdometro = res;
                      //console.log(res);
                    }
                  });

                   if (validateOdometro.Exitoso == 0) {
                      this.$vs.notify({
                        time: 5000,
                        color: "danger",
                        title: "Alerta",
                        text: validateOdometro.mensaje
                      });

                      setTimeout(() => {
                        this.$vs.loading.close();
                      }, 500);
                      reject("correct all values");
                    }
                    else{
                      setTimeout(() => {
                        this.$vs.loading.close();
                        }, 500);
                        resolve(true);
                                    
                      
                      if (this.HojaRID == 0) {
                          if (this.CuestionarioEmpresa.Secciones.length > 0) {
                            for (let s in this.CuestionarioEmpresa.Secciones) {
                              for (let p in this.CuestionarioEmpresa.Secciones[s].Preguntas) {
                                  this.selected.push(
                                    this.CuestionarioEmpresa.Secciones[s]
                                      .Preguntas[p]
                                  );
                                }
                            }
                          }
                        } else if (this.HojaRID > 0) {
                          if (this.CuestionarioEmpresa.Secciones.length > 0) {
                            for (let s in this.CuestionarioEmpresa.Secciones) {
                              for (let p in this.CuestionarioEmpresa
                                  .Secciones[s].Preguntas) {
                                  this.selected.push(
                                    this.CuestionarioEmpresa.Secciones[s]
                                      .Preguntas[p]
                                  );
                                }
                            }
                          }
                        }
                      }
                } else {
                  resolve(true);
                }
              }
            
              //validacion de servicios y rutinas
              if(!this.checkRutinas && !this.checkServicios){
                  this.$vs.notify({
                        time: 5000,
                        color: "danger",
                        title: "Alerta",
                        text: "Seleccione una rutina o servicio."
                      });
                      reject("correct all values");
                      alert("ok");
              }else{
                  if(this.checkRutinas){
                    if(this.idRutina===null || this.idRutina.id<=0 || this.idRutina.id==="Empty"){
                      this.$vs.notify({
                        time: 5000,
                        color: "danger",
                        title: "Alerta",
                        text: "Seleccione una rutina"
                      });
                      reject("correct all values");
                    }else{
                      resolve(true);
                    }
                  }
                  else if(this.checkServicios){
                    if(this.selectedTableServicios===null || this.selectedTableServicios.length===0){
                         this.$vs.notify({
                        time: 5000,
                        color: "danger",
                        title: "Alerta",
                        text: "Seleccione un servicio"
                      });
                      reject("correct all values");
                    }else{
                       resolve(true);
                    }
                  }
              }

            } else {
              this.$vs.loading();
              let USOdometro = {
                VehiculoID: vm.idVehiculo.id,
                Odometro: this.Kilometraje.split(",").join(""),
                LongitudID: 1
              };

              $.ajax({
                url: this.Api + "/api/Vehiculo/ValidateOdometro",
                type: "POST",
                dataType: "Json",
                async: false,
                data: USOdometro,
                success: res => {
                  validateOdometro = res;
                }
              });

              if (validateOdometro.Exitoso == 0) {
                this.$vs.notify({
                  time: 5000,
                  color: "danger",
                  title: "Alerta",
                  text: validateOdometro.mensaje
                });

                setTimeout(() => {
                  this.$vs.loading.close();
                }, 500);
                reject("correct all values");
              } else {
                setTimeout(() => {
                  this.$vs.loading.close();
                }, 500);
                //resolve(true);
                if (this.HojaRID == 0) {
                          if (this.CuestionarioEmpresa.Secciones.length > 0) {
                            for (let s in this.CuestionarioEmpresa.Secciones) {
                              for (let p in this.CuestionarioEmpresa.Secciones[s].Preguntas) {
                                  this.selected.push(
                                    this.CuestionarioEmpresa.Secciones[s]
                                      .Preguntas[p]
                                  );
                                }
                            }
                          }
                        } else if (this.HojaRID > 0) {
                          if (this.CuestionarioEmpresa.Secciones.length > 0) {
                            for (let s in this.CuestionarioEmpresa.Secciones) {
                              for (let p in this.CuestionarioEmpresa
                                  .Secciones[s].Preguntas) {
                                  this.selected.push(
                                    this.CuestionarioEmpresa.Secciones[s]
                                      .Preguntas[p]
                                  );
                                }
                            }
                          }
                        }
              }

              //validacion de servicios y rutinas
              if(!this.checkRutinas && !this.checkServicios){
                  this.$vs.notify({
                        time: 5000,
                        color: "danger",
                        title: "Alerta",
                        text: "Seleccione una rutina o servicio."
                      });
                      reject("correct all values");
                      //alert("ok");
              }else{
                  if(this.checkRutinas){
                    if(this.idRutina===null || this.idRutina.id<=0 || this.idRutina.id==="Empty"){
                      this.$vs.notify({
                        time: 5000,
                        color: "danger",
                        title: "Alerta",
                        text: "Seleccione una rutina"
                      });
                      reject("correct all values");
                    }else{
                      resolve(true);
                    }
                  }
                  else if(this.checkServicios){
                    if(this.selectedTableServicios===null || this.selectedTableServicios.length===0){
                         this.$vs.notify({
                        time: 5000,
                        color: "danger",
                        title: "Alerta",
                        text: "Seleccione un servicio"
                      });
                      reject("correct all values");
                    }else{
                       resolve(true);
                    }
                  }
              }
            }
          } else {
            setTimeout(() => {
              this.$vs.loading.close();
            }, 500);
            reject("correct all values");
          }
        });
      });
    },
    validateStep3() {
      return new Promise((resolve, reject) => {
        resolve(true);
        reject("correct all values");
      });
    },
    validateStep4() {
      return new Promise((resolve, reject) => {
        resolve(true);
        reject("correct all values");
        //this.loadSignatures();
      });
    },
    validateStep5() {
      return new Promise((resolve, reject) => {
        if (this.ArrayFirmas.length > 0) {
          let validateFirma = true;
          for (var index in this.ArrayFirmas) {
            if (this.HojaRID > 0) {
              if (this.ArrayFirmas[index].Firma.Firma) {
                const { isEmpty, data } = this.$refs.signaturePad[
                  index
                ].saveSignature();

                if (!isEmpty) {
                  this.ArrayFirmas[index].Firma.Firma = data;
                }

                if (!this.ArrayFirmas[index].Firma.Nombre) {
                  validateFirma = false;
                }
              } else {
                const { isEmpty, data } = this.$refs.signaturePad[
                  index
                ].saveSignature();

                if (!isEmpty) {
                  this.ArrayFirmas[index].Firma.Firma = data;
                } else {
                  validateFirma = false;
                  this.ArrayFirmas[index].Firma.Firma = null;
                }

                if (!this.ArrayFirmas[index].Firma.Nombre) {
                  validateFirma = false;
                }

                if (validateFirma == false) {
                  this.$vs.notify({
                    time: 5000,
                    fixed: true,
                    color: "danger",
                    title: this.ArrayFirmas[index].Nombre,
                    text: "Los campos nombre y firma son requeridos."
                  });
                }
              }
            } else {
              const { isEmpty, data } = this.$refs.signaturePad[
                index
              ].saveSignature();

              if (!isEmpty) {
                this.ArrayFirmas[index].Firma.Firma = data;
              } else {
                validateFirma = false;
                this.ArrayFirmas[index].Firma.Firma = null;
              }

              if (!this.ArrayFirmas[index].Firma.Nombre) {
                validateFirma = false;
              }

              if (validateFirma == false) {
                this.$vs.notify({
                  time: 5000,
                  fixed: true,
                  color: "danger",
                  title: this.ArrayFirmas[index].Nombre,
                  text: "Los campos nombre y firma son requeridos."
                });
              }
            }
          }

          //console.log(this.ArrayFirmas);
          if (validateFirma) {
            resolve(true);
          }
          reject("correct all values");
        } else {
          resolve(true);
          reject("correct all values");
        }
      });
    },
    forceRerenderForm() {
      this.renderForm = false;
      this.$nextTick(() => {
        this.renderForm = true;
      });
    },
    //SAVE

    saveInformacion() {
      this.$vs.loading();

      const vm = this;
      const datosSend = {};
      datosSend.EmpresaID = authConfig.EmpresaId;
      datosSend.HojaRecepcionID = vm.HojaRID;
      datosSend.HojaInspeccionID =vm.HojaIID!==null && vm.HojaIID.id!==null? vm.HojaIID.id:0;
      datosSend.FechaCreacion =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate();
      datosSend.InspectorID = vm.fgInspector.fgVisible
        ? vm.idEmpleado ? vm.idEmpleado.id
        : null : null;
      datosSend.ClienteID = vm.fgCliente.fgVisible ? vm.idCliente.id : null;
      datosSend.Contrato = vm.fgContrato.fgVisible ? vm.Contrato : null;
      datosSend.Factura = vm.fgFactura.fgVisible ? vm.Factura : null;
      datosSend.Estacion = vm.fgEstacion.fgVisible ? vm.idEstacion.label : null;
      datosSend.VehiculoID = vm.fgVehiculo.fgVisible ? vm.idVehiculo.id : null;
      datosSend.TipoVehiculoID = vm.fgTipoVehiculo.fgVisible
        ? vm.idTipoVehiculo.id
        : null;
      datosSend.NombreCliente = vm.fgNombreCliente.fgVisible ? vm.Nombre : null;
      datosSend.TipoDocumentoID = vm.fgTipoDocumento.fgVisible
        ? vm.idTipoDocumento.id
        : null;
      datosSend.TipoCombustibleID = vm.idTipoCombustible != null ? vm.idTipoCombustible.id : null;
      datosSend.Combustible = vm.idCombustible != null ? vm.idCombustible.id : null;
      datosSend.RutinaID = vm.idRutina != null ? vm.idRutina.id : null;
      datosSend.EsPorRutina=vm.hojaResepcionEsPorRutina;
      datosSend.ServiciosSeleccionados=[];
      datosSend.ServiciosSeleccionados=vm.selectedTableServicios;
      datosSend.Kilometraje = vm.fgkilometraje.fgVisible
        ? vm.Kilometraje.split(",").join("")
        : null;
      //Llegadas
      datosSend.FechaFin = vm.fgFechaFinal.fgVisible
        ? new Date(vm.fLlegada).getFullYear() +
          "-" +
          (new Date(vm.fLlegada).getMonth() + 1) +
          "-" +
          new Date(vm.fLlegada).getDate()
        : null;
      datosSend.FechaInicio = vm.fgFechaInicio.fgVisible
        ? new Date(vm.fSalida).getFullYear() +
          "-" +
          (new Date(vm.fSalida).getMonth() + 1) +
          "-" +
          new Date(vm.fSalida).getDate()
        : null;
      datosSend.TrabajoRealizar = vm.fgObservaciones.fgVisible
        ? vm.Comentarios
        : null;
      datosSend.Activo = 1;
      datosSend.Sincronizada = false;
      // datosSend.TipoChasisID = vm.fgTipoChasis.fgVisible
      //   ? vm.idTipoChasis.id
      //   : null;
      datosSend.Averias = vm.pointsMarker;
      datosSend.Cuestionario = [];
      if (vm.selected.length > 0) {
        for (let i = 0; i < vm.selected.length; i++) {
          let objCuestionario = {};
          //objCuestionario.HojaInspeccionID = HiID;
          objCuestionario.PreguntaID = vm.selected[i].PreguntaID;
          objCuestionario.RespuestaID =
            vm.selected[i].Respuestas[0].RespuestaID;
          datosSend.Cuestionario.push(objCuestionario);
        }
      }

      datosSend.Firmas = vm.ArrayFirmas;
      let validateOdometro = {};

        let UOdometro = {
          VehiculoID: vm.idVehiculo.id,
          Odometro: datosSend.Kilometraje,
          LongitudID: 1,
        };
        $.ajax({
          url: this.Api + "/api/Vehiculo/UpdateOdometro",
          type: "POST",
          dataType: "Json",
          async: false,
          data: UOdometro,
          success: (res) => {
            validateOdometro = res;
          },
        });

        if (validateOdometro.Exitoso == 0) {
          this.$vs.notify({
            time: 5000,
            color: "danger",
            title: "Alerta",
            text: validateOdometro.mensaje,
          });

          setTimeout(() => {
            this.$vs.loading.close();
          }, 500);
          return;
        }
      $.ajax({
        url: this.WS + "/Checklist/saveHojaRecepcion",
        type: "POST",
        dataType: "Json",
        async: false,
        data: datosSend,
        success: res => {
          if (res.Estatus == -1) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: "Ocurrió un error inesperado, favor de intentarlo de nuevo."
            });

            setTimeout(() => {
              this.$vs.loading.close();
            }, 500);
            return;
          } else if (res.Estatus == 0) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "Alerta",
              text: res.Mensaje
            });
            this.$vs.loading.close();
            return;
          }

          //vm.saveCuestionario(res.body.hojasInspeccion[0].HojaInspeccionID);
          //vm.getInfoInspeccionxID(res.Data);
          if (vm.HojaRID > 0) {
            this.$vs.notify({
              time: 5000,
              color: "success",
              fixed: true,
              title: "Operación exitosa",
              text:
                "La hoja de recepción No: " +
                res.Data +
                " se ha actualizado correctamente"
            });
            //se agrego la limpieza
            //this.clearForm();
          } else {
            this.$vs.notify({
              time: 5000,
              fixed: true,
              color: "success",
              title: "Operación exitosa",
              text: "Hoja de recepción creada con éxito No: " + res.Data
            });
          }

          setTimeout(() => {
            this.$vs.loading.close();
            this.popupActive = false;
            this.forceRerenderForm();
            vm.searchRecepcion();
          }, 500);
        },
        error: function() {
          //console.log(errorThrown)
          this.$vs.notify({
            time: 5000,
            color: "warning",
            title: "Ocurrió un error inesperado",
            text: "No se ha podido conectar al servidor. Intente más tarde"
          });

          setTimeout(() => {
            this.$vs.loading.close();
          }, 500);
        }
      });
    },

    //Catálogos

    getClientes() {
      $.ajax({
        url: this.Api + "/api/Cliente/GetByEmpresaID/" + authConfig.EmpresaId, //this.$route.query.Id;,
        type: "GET",
        dataType: "Json",
        async: false,
        success: res => {
          if (res.error) {
            throw new Error(res.error);
          }
          for (var i in res) {
            this.options1.push({
              id: res[i].ClienteID,
              label: res[i].Nombre
            });
          }
        }
      });
    },
    getSucursales() {
      $.ajax({
        url: this.Api + "/api/Reportes/ConsultarSucursales",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId }, //this.$route.query.Id;,
        async: false,
        success: res => {
          if (res.error) {
            throw new Error(res.error);
          }
          for (var i in res.obj) {
            this.options5.push({
              id: res.obj[i].sucursal_id,
              label: res.obj[i].sucursal_nombre
            });
          }
        }
      });
    },
    getVehiculos() {
      $.ajax({
        url:
          this.Api + "/api/Vehiculo/GetByEmpresaIDNS/" + authConfig.EmpresaId,
        type: "GET",
        dataType: "Json",
        async: false,
        success: res => {
          if (res.error) {
            throw new Error(res.error);
          }
          this.LsAllVehiculos = [];
          for (var i in res) {
            this.LsAllVehiculos.push(res[i]);
            this.options4.push({
              id: res[i].VehiculoID,
              label: res[i].Nombre
            });
          }
        }
      });
    },
    getVehiculosByTipo(id) {
      this.options4 = [];
      this.LsVehiculos = [];
      for (var i in this.LsAllVehiculos) {
        if (this.LsAllVehiculos[i].TipoVehiculo.TipoVehiculoID == id) {
          this.LsVehiculos.push(this.LsAllVehiculos[i]);

          this.options4.push({
            id: this.LsAllVehiculos[i].VehiculoID,
            label: this.LsAllVehiculos[i].Nombre
          });
        }
      }
      this.idVehiculo = this.options4[0];
    },
    getEmpleados() {
      $.ajax({
        url:
          this.Api +
          "/api/EmpleadoUsuario/GetAllEmpleadosByEmpresaID/" +
          authConfig.EmpresaId, //this.$route.query.Id;,
        type: "GET",
        dataType: "Json",
        async: false,
        success: res => {
          if (res.error) {
            throw new Error(res.error);
          }
          for (var i in res) {
            this.options6.push({
              id: res[i].EmpleadoID,
              label: res[i].Nombre
            });
          }
        }
      });
    },
    getLlantasVehiculo(x) {
      $.ajax({
        url: this.Api + "/api/Llantas/GetByVehiculoIDSNV/" + x,
        type: "GET",
        dataType: "Json",
        success: res => {
          if (res.error) {
            throw new Error(res.error);
          }
          this.LsLlantas = res;
        }
      });
    },
    getTiposVehiculos() {
      $.ajax({
        url: this.WS + "/Checklist/getTiposVehiculosByEmpresa",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId }, //this.$route.query.Id;,
        success: res => {
          if (res.error) {
            throw new Error(res.error);
          }
          this.TiposVehiculos = res.Data;
        }
      });
    },
    getCuestionario(tipoVehiculo) {
      $.ajax({
        url: this.WS + "/Checklist/getCuestionarioByEmpresa",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId, ID: 2,TipoVehiculoID:tipoVehiculo.id }, //this.$route.query.Id;,
        success: res => {
          if (res.error) {
            throw new Error(res.error);
          }
          this.CuestionarioEmpresa = res.Data;
        }
      });
    },
    getTipoDocumentos() {
      $.ajax({
        url: this.WS + "/Checklist/getTipoDocumentos",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId, ID: 1 }, //this.$route.query.Id;,
        success: res => {
          if (res.error) {
            throw new Error(res.error);
          }
          this.options2 = res.Data;
        }
      });
    },
    getFolioHojaRecepcion() {
      let vm = this;
      $.ajax({
        url: vm.WS + "/Checklist/getFolioHojaRecepcion",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId, ID: 1, type: "1" },
        success: (res) => {
          if (res.Estatus === 1) {
            //this.ArrayFirmas = res.Data;
          }else{
            this.ActiveHI = false;
            this.$vs.notify({
                time: 6000,
                color: "danger",
                title: "Alerta",
                text:
                  "No es posible registrar una hoja de recepción debido a que no existe folio para la empresa "+ res.Data,
              });
          }
        },
      });
    },
    getHojasInspeccion() {
      $.ajax({
        url: this.WS + "/Checklist/getHojasInspeccion",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId }, //this.$route.query.Id;,
        success: res => {
          if (res.error) {
            throw new Error(res.error);
          }
          this.HojasInspeccion = res.Data;
        }
      });
    },
    getTiposCombustible() {
      $.ajax({
        url: this.WS + "/Checklist/getTiposCombustible",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId }, //this.$route.query.Id;,
        success: res => {
          if (res.error) {
            throw new Error(res.error);
          }
          this.options8 = res.Data;
        }
      });
    },
    getCamposHojaInspeccion() {
      let vm = this;
      $.ajax({
        url: vm.WS + "/Checklist/CamposHojaInspeccionByEmpresa",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId, ID: 2 },
        success: (res) => {
          let dict = {
            custom: {}
          };
          //campo cliente
          // dict.custom["v_idCliente"] = {
          //   required: "El campo cliente es requerido."
          // };
          vm.fgCliente.fgVisible =
            res.Data.filter(item => {
              if (item.Campo == vm.fgCliente.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_idCliente"] = {
                    required: "El campo cliente es requerido."
                  };
                } else {
                  vm.idCliente = { id: 0, label: "" };
                }
                return item;
                // dict.custom.push({
                //   "v_idCliente": {
                //     "required": "El campo cliente es requerido."
                //   }}
                // )
              }
            })[0].Visible == 1
              ? true
              : false;

          //fin campo cliente

          dict.custom["v_Nombre"] = {
            required: "El campo nombre es requerido."
          };

          dict.custom["v_idTipoDocumento"] = {
            required: "El campo tipo de documento es requerido."
          };

          dict.custom["v_idTipoVehiculo"] = {
            required: "El campo tipo de vehículo es requerido."
          };

          dict.custom["v_idTipoVehiculo"] = {
            required: "El campo tipo de vehículo es requerido."
          };

          dict.custom["v_idVehiculo"] = {
            required: "El campo vehículo es requerido."
          };

          dict.custom["v_idEstacion"] = {
            required: "El campo estación dueña es requerido."
          };

          dict.custom["v_idEmpleado"] = {
            required: "El campo inspector de operaciones es requerido."
          };   
          
          dict.custom["v_idCombustible"] = {
            required: "El campo combustible de salida es requerido."
          }

           dict.custom["v_idRutina"] = {
            required: "El campo rutina es requerido."
          }

          // vm.fgCliente.fgVisible =
          //   res.Data.filter(item => {
          //     if (item.Campo == vm.fgCliente.Campo) {
          //       if (item.Visible == 1) {
          //         dict.custom["v_idCliente"] = {
          //           required: "El campo cliente es requerido."
          //         };
          //       } else {
          //         vm.idCliente = { id: 0, label: "" };
          //       }
          //       return item;
          //       // dict.custom.push({
          //       //   "v_idCliente": {
          //       //     "required": "El campo cliente es requerido."
          //       //   }}
          //       // )
          //     }
          //   })[0].Visible == 1
          //     ? true
          //     : false;
          // vm.fgNombreCliente.fgVisible =
          //   res.Data.filter(item => {
          //     if (item.Campo == vm.fgNombreCliente.Campo) {
          //       if (item.Visible == 1) {
          //         dict.custom["v_Nombre"] = {
          //           required: "El campo nombre es requerido."
          //         };
          //       } else {
          //         vm.NombreCliente = "Empty";
          //       }
          //       return item;
          //     }
          //   })[0].Visible == 1
          //     ? true
          //     : false;
          // vm.fgTipoDocumento.fgVisible =
          //   res.Data.filter(item => {
          //     if (item.Campo == vm.fgTipoDocumento.Campo) {
          //       if (item.Visible == 1) {
          //         dict.custom["v_idTipoDocumento"] = {
          //           required: "El campo tipo de documento es requerido."
          //         };
          //       } else {
          //         vm.idTipoDocumento = { id: 0, label: "" };
          //       }
          //       return item;
          //     }
          //   })[0].Visible == 1
          //     ? true
          //     : false;
          // vm.fgTipoVehiculo.fgVisible =
          //   res.Data.filter(item => {
          //     if (item.Campo == vm.fgTipoVehiculo.Campo) {
          //       if (item.Visible == 1) {
          //         dict.custom["v_idTipoVehiculo"] = {
          //           required: "El campo tipo de vehículo es requerido."
          //         };
          //       } else {
          //         vm.idTipoVehiculo = { id: 0, label: "" };
          //       }
          //       return item;
          //     }
          //   })[0].Visible == 1
          //     ? true
          //     : false;
          // vm.fgVehiculo.fgVisible =
          //   res.Data.filter(item => {
          //     if (item.Campo == vm.fgVehiculo.Campo) {
          //       if (item.Visible == 1) {
          //         dict.custom["v_idVehiculo"] = {
          //           required: "El campo vehículo es requerido."
          //         };
          //       } else {
          //         vm.idVehiculo = { id: 0, label: "" };
          //       }
          //       return item;
          //     }
          //   })[0].Visible == 1
          //     ? true
          //     : false;
          vm.fgTipoChasis.fgVisible = false;
          // res.Data.filter(item => {
          //   if (item.Campo == vm.fgTipoChasis.Campo) {
          //     if (item.Visible == 1) {
          //       dict.custom["v_idTipoChasis"] = {
          //         required: "El campo tipo de chasis es requerido."
          //       };
          //     }
          //     return item;
          //   }
          // })[0].Visible == 1
          //   ? true
          //   : false;
          // vm.fgEstacion.fgVisible =
          //   res.Data.filter(item => {
          //     if (item.Campo == vm.fgEstacion.Campo) {
          //       if (item.Visible == 1) {
          //         dict.custom["v_idEstacion"] = {
          //           required: "El campo estación dueña es requerido."
          //         };
          //       } else {
          //         vm.idEstacion = { id: 0, label: "" };
          //       }
          //       return item;
          //     }
          //   })[0].Visible == 1
          //     ? true
          //     : false;
          // vm.fgInspector.fgVisible =
          //   res.Data.filter(item => {
          //     if (item.Campo == vm.fgInspector.Campo) {
          //       if (item.Visible == 1) {
          //         dict.custom["v_idEmpleado"] = {
          //           required: "El campo inspector de operaciones es requerido."
          //         };
          //       } else {
          //         vm.idEmpleado = { id: 0, label: "" };
          //       }
          //       return item;
          //     }
          //   })[0].Visible == 1
          //     ? true
          //     : false;
          // vm.fgContrato.fgVisible =
          //   res.Data.filter(item => {
          //     if (item.Campo == vm.fgContrato.Campo) {
          //       if (item.Visible == 1) {
          //         // dict.custom["v_Contrato"] = {
          //         //   required: "El campo contrato es requerido."
          //         // };
          //       } else {
          //         vm.Contrato = "";
          //       }
          //       return item;
          //     }
          //   })[0].Visible == 1
          //     ? true
          //     : false;
          // vm.fgFactura.fgVisible =
          //   res.Data.filter(item => {
          //     if (item.Campo == vm.fgFactura.Campo) {
          //       if (item.Visible == 1) {
          //         // dict.custom["v_Factura"] = {
          //         //   required: "El campo factura es requerido."
          //         // };
          //       } else {
          //         vm.Factura = "";
          //       }
          //       return item;
          //     }
          //   })[0].Visible == 1
          //     ? true
          //     : false;
          //contrato y factura
           vm.fgContrato.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgContrato.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_Contrato"] = {
                    required: "El campo contrato es requerido.",
                  };
                } else {
                  vm.Contrato = "Empty";
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgContrato.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_Contrato"] = {
                    required: "El campo contrato es requerido.",
                  };
                } else {
                  vm.Contrato = "Empty";
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          vm.fgFactura.fgVisible =
            (res.Data.filter((item) => {
              if (item.Campo == vm.fgFactura.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_Factura"] = {
                    required: "El campo factura es requerido.",
                  };
                } else {
                  vm.Factura = "Empty";
                }
                return item;
              }
            })).length > 0 ? res.Data.filter((item) => {
              if (item.Campo == vm.fgFactura.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_Factura"] = {
                    required: "El campo factura es requerido.",
                  };
                } else {
                  vm.Factura = "Empty";
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false : false;
          //contrato y factura fin
          vm.fgFechaInicio.fgVisible =
            res.Data.filter(item => {
              if (item.Campo == vm.fgFechaInicio.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_FechaInicio"] = {
                    required: "El campo fecha de inicio es requerido."
                  };
                } else {
                  //vm.idTipoVehiculo = { id:0, label:''}
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false;
          vm.fgFechaFinal.fgVisible =
            res.Data.filter(item => {
              if (item.Campo == vm.fgFechaFinal.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_FechaFinal"] = {
                    required: "El campo fecha fin es requerido."
                  };
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false;
          vm.fgkilometraje.fgVisible =
            res.Data.filter(item => {
              if (item.Campo == vm.fgkilometraje.Campo) {
                if (item.Visible == 1) {
                  dict.custom["v_kilometraje"] = {
                    required: "El campo kilometraje es requerido."
                  };
                }
                return item;
              }
            })[0].Visible == 1
              ? true
              : false;
          vm.fgObservaciones.fgVisible =
            res.Data.filter(item => {
              if (item.Campo == vm.fgObservaciones.Campo) {
                return item;
              }
            })[0].Visible == 1
              ? true
              : false;
          //console.log(dict);
          Validator.localize("en", dict);
        }
      });
    },
    getCamposFirmas() {
      let vm = this;
      $.ajax({
        url: vm.WS + "/Checklist/CamposFirmasByEmpresa",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId, ID: 2 },
        success: res => {
          if (res.Estatus === 1) {
            this.ArrayFirmas = res.Data;
          }
        }
      });
    },
    getUltimaHojaRecepcionByVehiculo(vehiculo){

      let vehPropio=false;
      if(vehiculo.VehiculoPropio===1){
        vehPropio=true;
      }
      $.ajax({
        url: this.WS + "/Checklist/getUltimaHojaRecepcionByVehiculo",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId, ID: vehiculo.VehiculoID,VehiculoPropio:vehPropio }, //this.$route.query.Id;,
        success: res => {
          // if (res.error) {
          //   throw new Error(res.error);
          // }
          //this.options2 = res.Data;
           if (res.Estatus === 1) {
             if(vehPropio){
               this.Nombre = res.Data.Nombre;
             }else{
                this.Nombre = res.Data.NombreCliente;
             }
            
          }else{
            this.Nombre="";
          }
        }
      });
    },
    getRutinasByTipoVehiculo(TipoVehiculo){
      $.ajax({
        url: this.WS + "/Checklist/getRutinasByTipoVehiculo",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId, ID: TipoVehiculo.id }, //this.$route.query.Id;,
        success: res => {
          // if (res.error) {
          //   throw new Error(res.error);
          // }
          //this.options2 = res.Data;
           if (res.Estatus === 1) {
               this.optionsRutinas = res.Data;
          }else{
            this.optionsRutinas = [
                                      { id: "Empty", label: "Empty" }
                                    ];
          }
        }
      });
    },

    //tabla servicios
    checkAllServices(){
      let tempSer=[];
      tempSer= this.dataServicios;
      if(this.allCheck){
        tempSer.forEach(item=>{
          item.chequeado=false;
        });
         this.allCheck=false;
      }else{
          tempSer.forEach(item=>{
            item.chequeado=true;
          });
          this.allCheck=true;
      }

      this.addServiceSelected(tempSer,this.allCheck);
    },
    searchServices(){
      let filtesServices=[];
      let dataFilterInicial=[];
      if(this.search!=="" && this.search.length>5){
        this.totalPaginasServices=this.getTotalPaginas();
        this.serviciosFiltrados=true;
        dataFilterInicial=this.dataServiciosOriginal;
        if(this.busquedaExacta){
          filtesServices=dataFilterInicial.filter(p=> p.Nombre.toLowerCase()===this.search.toLowerCase());
        }else{
          filtesServices=dataFilterInicial.filter(p=> p.Nombre.toLowerCase().indexOf(this.search) > -1);
        }
        
        this.dataServiciosFiltrados=[];
        this.dataServiciosFiltrados=filtesServices;
        //console.log("filter......................");
      }else{
        this.totalPaginasServices=this.getTotalPaginas();
          this.serviciosFiltrados=false;
          this.dataServiciosFiltrados=[];
          //filtesServices=this.dataServiciosOriginal;
      }
      if(this.dataServiciosFiltrados!==null && this.dataServiciosFiltrados.length>0){
        //this.getLimitServicesByData(10,filtesServices);
        this.getDataPagina(1);
      }else{

        if(this.search.length>5 && this.search.length<9){
          this.$vs.notify({
          time: 5000,
          color: "warning",
          title: "Alerta",
          text: "No se encontraron más resultados con los datos proporcionados"
        });
        }
        
      }
      
    },
    getRespaldoServices(){
      if(this.dataServiciosOriginal!=null || this.dataServiciosOriginal.length===0){
          this.dataServiciosOriginal=this.dataServicios;
      }
    },
    getAllServices(){
      $.ajax({
        url: this.WS + "/Checklist/getAllServices",
        type: "POST",
        dataType: "Json",
        data: { EmpresaID: authConfig.EmpresaId,ID:this.HojaRID }, //this.$route.query.Id;,
        success: res => {
          if(res.Estatus===1){
              //this.dataServicios = res.Data;
              this.dataServiciosOriginal=res.Data;
              this.getDataPagina(1);
              this.totalPaginasServices=this.getTotalPaginas();
              this.getEstatusTextosServicios();
          }else{
            throw new Error(res.Mensaje);
          }
        }
      });
    },
    getEstatusRutinas(){
        if(this.checkRutinas){
           this.checkRutinas=false; 
           this.hojaResepcionEsPorRutina=false;
           this.showRutinas=false;
           this.showServices=false;
        }else{
          this.checkRutinas=true;
          this.hojaResepcionEsPorRutina=true;
          this.checkServicios=false;
          this.showRutinas=true;
           this.showServices=false;
        }
        
    },
    getEstatusServicios(){
        if(this.checkServicios){
          this.checkServicios=false;
          this.showServices=false;
           this.showRutinas=false;
        }else{
          this.checkServicios=true;
          this.checkRutinas=false; 
           this.showServices=true;
           this.showRutinas=false;
            this.hojaResepcionEsPorRutina=false;
           if(!this.serviciosConsultados){
             this.serviciosConsultados=true;
             this.getAllServices();
           }
        }
    },
    // getLimitServicesInicial(max){
    //   let dataLimit=[];
    //   for (let index = 0; index < max; index++) {
    //     dataLimit.push(this.dataServiciosOriginal[index])
    //   }
    //   this.dataServicios=[];
    //   this.dataServicios=dataLimit;
    // },
    // getLimitServicesByData(max,servicioAlimitar){

    //   if(servicioAlimitar!==null && servicioAlimitar.length>0){
    //         let dataLimit=[];
    //       for (let index = 0; index < max; index++) {
    //         dataLimit.push(servicioAlimitar[index])
    //       }
    //       this.dataServicios=[];
    //       this.dataServicios=dataLimit;
    //   }
      
    // },
    getEstatusTextosServicios(){
      let totalSeleccionados=0;
      //let total=0, totalSeleccionados=0, totalEnPantalla=0;
      //total=this.dataServiciosOriginal.length;
      totalSeleccionados=this.selectedTableServicios===null?0:this.selectedTableServicios.length;
      //totalEnPantalla=this.dataServicios===null?0:this.dataServicios.length;

      //this.textoTotalServicios=""+totalEnPantalla+" / "+total;
      this.textoTotalServiciosSeleccionados=""+totalSeleccionados+" Seleccionados";
    },
    addServiceSelected(serviciosEnpantalla,seleccionarTodo){

      if(seleccionarTodo){
        //console.log("agregar todo");
          if(this.selectedTableServicios!=null && this.selectedTableServicios.length>0){
           //console.log("tiene datos length "+this.selectedTableServicios.length);
            serviciosEnpantalla.forEach(item=>{
              if(item.chequeado){
                let existeLocal=false;
                this.selectedTableServicios.forEach(existente=>{
                    if(existente.ServicioID===item.ServicioID){
                      //console.log("existe");
                      existeLocal=true;
                    }
                });
                if(!existeLocal){
                  //console.log("agregado");
                    this.selectedTableServicios.push({ServicioID:item.ServicioID,Nombre:item.Nombre,
                                                        TipoServicioID:item.TipoServicioID,EmpresaID:item.EmpresaID,
                                                        TipoServicioNombre:item.TipoServicioNombre,chequeado:item.chequeado});
                }
              }
            });
          }else{
            this.selectedTableServicios=[];
            serviciosEnpantalla.forEach(item=>{
              if(item.chequeado){
                this.selectedTableServicios.push({ServicioID:item.ServicioID,Nombre:item.Nombre,
                                                    TipoServicioID:item.TipoServicioID,EmpresaID:item.EmpresaID,
                                                    TipoServicioNombre:item.TipoServicioNombre,chequeado:item.chequeado});
              }
            });
          }
      }else{
          //console.log("quitar todo");
           let deOtraVista=[];
              deOtraVista=this.selectedTableServicios.filter(existente=>serviciosEnpantalla.forEach(pantalla=>existente.ServicioID!=pantalla.ServicioID));
              this.selectedTableServicios=[];
              this.selectedTableServicios=deOtraVista;
      }
        
      this.getEstatusTextosServicios();

    },
    checkItemService(serv,event){
      //console.log("uno por uno");

      if(event.target.checked){
        this.selectedTableServicios.push({ServicioID:serv.ServicioID,Nombre:serv.Nombre,
                                                TipoServicioID:serv.TipoServicioID,EmpresaID:serv.EmpresaID,
                                                TipoServicioNombre:serv.TipoServicioNombre,chequeado:serv.chequeado});
        
      }else{
        let arrayTempnoEliminar=[];
        this.selectedTableServicios.forEach(x=>{
            if(x.ServicioID!=serv.ServicioID){
              arrayTempnoEliminar.push({ServicioID:x.ServicioID,Nombre:x.Nombre,
                                                TipoServicioID:x.TipoServicioID,EmpresaID:x.EmpresaID,
                                                TipoServicioNombre:x.TipoServicioNombre,chequeado:x.chequeado});
            }
        });
        this.selectedTableServicios=[];
        this.selectedTableServicios=arrayTempnoEliminar;
      }

      this.getEstatusTextosServicios();
    },
    verServiciosSeleccionados(){

      if(this.selectedTableServicios!==null && this.selectedTableServicios.length>0){
          if(this.serviciosSeleccionadosEnPantalla){
            this.serviciosSeleccionadosEnPantalla=false;
            this.dataServicios=[];
            this.dataServicios=this.respaldoServiciosEnPantalla;
            this.textoTotalServicios=""+this.dataServicios.length+" / "+this.dataServiciosOriginal.length;
          }else{
            this.serviciosSeleccionadosEnPantalla=true;
            this.respaldoServiciosEnPantalla=[];
            this.respaldoServiciosEnPantalla=this.dataServicios;

            this.selectedTableServicios.forEach(x=>{
              x.chequeado=true;
            });
            this.dataServicios=[];
            this.dataServicios=this.selectedTableServicios;
            this.textoTotalServicios=""+this.dataServicios.length+" / "+this.dataServiciosOriginal.length;
          }
         
      }
      else if(this.selectedTableServicios.length===0 && this.serviciosSeleccionadosEnPantalla){
          if(this.respaldoServiciosEnPantalla!==null && this.respaldoServiciosEnPantalla.length>0){
            this.respaldoServiciosEnPantalla.forEach(x=>{
              if(x.chequeado){
                x.chequeado=false;
              }
            });
            this.serviciosSeleccionadosEnPantalla=false;
            this.dataServicios=[];
            this.dataServicios=this.respaldoServiciosEnPantalla;
            this.textoTotalServicios=""+this.dataServicios.length+" / "+this.dataServiciosOriginal.length;
          }
      }
      else{
        this.serviciosSeleccionadosEnPantalla=false;
        this.respaldoServiciosEnPantalla=[];
         this.$vs.notify({
          time: 5000,
          color: "warning",
          title: "Alerta",
          text: "No hay servicios seleccionados"
        });
      }
      
    },
    //optimizacion tabla
    getTotalPaginas(){
      let totalPA=0;
      if(this.serviciosFiltrados && this.dataServiciosFiltrados.length>0){
          totalPA=Math.ceil(this.dataServiciosFiltrados.length/this.elemetosPorPagina);
      }else{
         totalPA=Math.ceil(this.dataServiciosOriginal.length/this.elemetosPorPagina);
      }
      return totalPA;
    },
    getDataPagina(noPagina){
      this.dataServicios=[];
      this.page=noPagina;
      let ini=(noPagina*this.elemetosPorPagina)-this.elemetosPorPagina;
      let fin=(noPagina*this.elemetosPorPagina);
      if(this.serviciosFiltrados && this.dataServiciosFiltrados.length>0){
        this.dataServicios=this.dataServiciosFiltrados.slice(ini,fin);
      }else{
        this.dataServicios=this.dataServiciosOriginal.slice(ini,fin);
      }
      this.getUpdateEstatusTextosServiciosContador(fin);
    },
    getPreviousPage(){
      if(this.page>1){
        this.page--;
      }
      this.getDataPagina(this.page);
    },
     getNetxPage(){
      if(this.page<this.getTotalPaginas()){
        this.page++;
      }
      this.getDataPagina(this.page);
    },
    getUpdateEstatusTextosServiciosContador(totalEnPantalla=0){
      let total=0;
      total=this.dataServiciosOriginal.length;

      this.textoTotalServicios=""+totalEnPantalla+" / "+total;
    },
    getResetItemsbyTable(){
      this.selectedTableServicios=[];
      this.dataServicios= [];
      this.dataServiciosFiltrados=[];
      this.serviciosFiltrados=false;
      this.search='';
      this.page= 1;
      this.totalPaginasServices=0;
        this.allCheck=false;
        this.dataServiciosOriginal=[];
        this.checkRutinas=false;
        this.checkServicios=false;
        this.showRutinas=false;
        this.showServices=false;
        this.serviciosConsultados=false;
        this.textoTotalServicios='';
        this.textoTotalServiciosSeleccionados='';
        this.hojaResepcionEsPorRutina=false;
        this.serviciosSeleccionadosEnPantalla=false;
        this.respaldoServiciosEnPantalla=[];
        this.busquedaExacta=false;
        this.idRutina= { id: "Empty", label: "Empty" };
        this.optionsRutinas=[
            { id: "Empty", label: "Empty" }
            ];
    }
  }
};
</script>